import React, { useEffect, useState } from 'react'
import { Accordion, Button, Form, Card, Row, Col, Container, Badge, Modal } from 'react-bootstrap'
import upload from '../../assets/images/Paper Upload.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {
    registerVendor,
    getManufacturerDetails,
    statusUpdateTiming,
    updateManufacturer,
} from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import { useFormik } from 'formik'
import imageToBase64 from 'image-to-base64/browser'
import { uploadBulkProducts } from '../../api/context/products'
import { Switch } from '@mui/material'
import { MdOutlineUploadFile } from 'react-icons/md'
import sampleFile from '../../assets/files/sample-sheet.xlsx'
import { useRecoilState } from 'recoil'
import { updateDetailsState } from '../../atoms/updateDetails'
import { BsEye, BsEyeSlash, BsInfoCircle, BsX, BsShieldCheck } from 'react-icons/bs'
import { IoMdArrowBack } from 'react-icons/io'
import GoogleMap from 'google-map-react'
import AsyncSelect from 'react-select/async';
import GooglePlacesAutocomplete, {
    geocodeByPlaceId,
    getLatLng,
} from 'react-google-places-autocomplete'
import { FaMapMarkerAlt, FaStore, FaRegBuilding, FaUniversity, FaRegClock } from 'react-icons/fa'
import { GOOGLE_MAP_API_KEY } from '../../utils/config'
import { FiUploadCloud, FiMapPin, FiArrowLeft, FiPhone, FiMail, FiHeadphones, FiSend, FiCrosshair, FiHome, FiBriefcase, FiCreditCard, FiClock, FiPlus, FiX, FiImage, FiCheck, FiTag } from 'react-icons/fi'
import { getBrandListing, createBrand } from '../../api/context/brand'
import { getCategoryListingPaginate, getSubCategoryListingPaginate } from '../../api/context/manufacturer'
import VendorRegistrationSuccessModal from './VendorRegistrationSuccessModal'


const RegisterManufacturer = () => {
    const navigate = useNavigate()

    const { id } = useParams()



    const [page, setPage] = useState(1);
    const [brands, setBrands] = useState([]);
    const [brandError, setBrandError] = useState(false);

    const [selectedBrands, setSelectedBrands] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    let typingTimer;


    const [selectedFiles, setSelectedFiles] = useState([])
    const [loading, setLoading] = useState(false)
    const [update, setUpdate] = useState(false)
    const [store, setStore] = useState([])
    const [bulkLoading, setBulkLoading] = useState(false)
    const [bulkModal, setBulkModal] = useState(false)
    const [refresh, setRefresh] = useRecoilState(updateDetailsState)
    const [showaccnumber, setShowAccnumber] = useState({
        accountNumber: false,
        reaccountNumber: false,
    })
    const [script, setScript] = useState(false)
    const [value, setValue] = useState(null)
    const [mapCenter, setMapCenter] = useState({ lat: 28.461272, lng: 77.026825 })
    const [showContactModal, setShowContactModal] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    // ===== Register Brand Modal state =====
    const [showRegisterBrandModal, setShowRegisterBrandModal] = useState(false)
    const [newBrandName, setNewBrandName] = useState('')
    const [newBrandImage, setNewBrandImage] = useState('')          // base64
    const [newBrandImagePreview, setNewBrandImagePreview] = useState('') // data url
    const [allCategories, setAllCategories] = useState([])
    const [categoriesLoading, setCategoriesLoading] = useState(false)
    const [brandCategoriesForm, setBrandCategoriesForm] = useState([]) // [{ categoryId, categoryName, subOptions:[], selectedSubs:[], loadingSubs }]
    const [creatingBrand, setCreatingBrand] = useState(false)

    const openRegisterBrandModal = () => {
        setNewBrandName('')
        setNewBrandImage('')
        setNewBrandImagePreview('')
        setBrandCategoriesForm([])
        setShowRegisterBrandModal(true)
        // Fetch categories on first open (same shape as EditBrandPage: response.results with {value,label})
        if (allCategories.length === 0) {
            setCategoriesLoading(true)
            getCategoryListingPaginate({ page: 1, limit: 100, search: '' })((response) => {
                if (response?.statusCode === 200) {
                    setAllCategories(response?.results || [])
                }
                setCategoriesLoading(false)
            })
        }
    }
    const closeRegisterBrandModal = () => {
        if (creatingBrand) return
        setShowRegisterBrandModal(false)
    }

    const handleNewBrandImage = (e) => {
        const file = e.target?.files?.[0]
        if (!file) return
        if (file.size > 2 * 1024 * 1024) {
            toast.error('Image must be under 2MB')
            return
        }
        if (!['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)) {
            toast.error('Only JPG, PNG, GIF, or WEBP images are supported')
            return
        }
        const reader = new FileReader()
        reader.onloadend = () => setNewBrandImagePreview(String(reader.result))
        reader.readAsDataURL(file)
        imageToBase64(file)
            .then((b64) => setNewBrandImage(b64))
            .catch(() => toast.error('Could not process the image'))
    }

    const toggleBrandCategory = (cat) => {
        // cat has {value, label} shape from getCategoryListingPaginate.results
        const catId = cat.value ?? cat.id
        const catName = cat.label ?? cat.name
        setBrandCategoriesForm((prev) => {
            const exists = prev.find((c) => c.categoryId === catId)
            if (exists) {
                return prev.filter((c) => c.categoryId !== catId)
            }
            const entry = {
                categoryId: catId,
                categoryName: catName,
                subOptions: [],
                selectedSubs: [],
                loadingSubs: true,
            }
            // Same call as EditBrandPage.fetchSubcategoriesForCategory
            getSubCategoryListingPaginate({ page: 1, pageSize: 100, search: '', categoryIds: [catId] })((response) => {
                if (response?.statusCode === 200) {
                    const opts = response?.results || []
                    setBrandCategoriesForm((cur) => cur.map((c) => c.categoryId === catId ? { ...c, subOptions: opts, loadingSubs: false } : c))
                } else {
                    setBrandCategoriesForm((cur) => cur.map((c) => c.categoryId === catId ? { ...c, subOptions: [], loadingSubs: false } : c))
                }
            })
            return [...prev, entry]
        })
    }
    const isCategoryPicked = (id) => brandCategoriesForm.some((c) => c.categoryId === id)
    const updateCategorySubs = (categoryId, selected) => {
        setBrandCategoriesForm((prev) => prev.map((c) => c.categoryId === categoryId ? { ...c, selectedSubs: selected || [] } : c))
    }

    const submitNewBrand = async () => {
        if (!newBrandName.trim()) { toast.error('Enter a brand name'); return }
        if (brandCategoriesForm.length === 0) { toast.error('Pick at least one category'); return }
        const missingSubs = brandCategoriesForm.find((c) => c.selectedSubs.length === 0)
        if (missingSubs) { toast.error(`Pick at least one subcategory for ${missingSubs.categoryName}`); return }

        const payload = {
            name: newBrandName.trim(),
            image: newBrandImage,
            categories: brandCategoriesForm.map((c) => ({
                categoryId: c.categoryId,
                subCategories: c.selectedSubs.map((s) => s.value),
                selectedSubCategory: c.selectedSubs,
            })),
        }
        setCreatingBrand(true)
        createBrand(payload)((response) => {
            if (response?.data?.statusCode === 200) {
                const created = response?.data?.data
                const createdId = created?.id
                // Re-fetch the brands list (list-brands-vendor) so we have
                // the fresh, canonical list from the server.
                fetchBrands().then((fresh) => {
                    setCreatingBrand(false)
                    // Auto-select the newly created brand from the fresh list
                    const newOption = createdId
                        ? (fresh.find((b) => b.value === createdId) || { value: createdId, label: created?.name || newBrandName.trim() })
                        : null
                    if (newOption) {
                        onBrandChange([...(selectedBrands || []), newOption])
                    }
                    toast.success('Brand registered')
                    setShowRegisterBrandModal(false)
                })
            } else {
                setCreatingBrand(false)
                toast.error(response?.data?.message || 'Could not register brand')
            }
        })
    }

    const [activeSection, setActiveSection] = useState('basic')
    const VFP_SECTIONS = [
        { key: 'basic',    label: 'Basic Info', shortLabel: 'Basic' },
        { key: 'location', label: 'Location',   shortLabel: 'Location' },
        { key: 'business', label: 'Business',   shortLabel: 'Business' },
        { key: 'bank',     label: 'Bank',       shortLabel: 'Bank' },
        { key: 'timings',  label: 'Timings',    shortLabel: 'Timings' },
    ]
    const activeSectionIndex = VFP_SECTIONS.findIndex((s) => s.key === activeSection)
    const goNextSection = () => {
        const next = VFP_SECTIONS[Math.min(activeSectionIndex + 1, VFP_SECTIONS.length - 1)]
        if (next?.key) setActiveSection(next.key)
    }
    const goPrevSection = () => {
        const prev = VFP_SECTIONS[Math.max(activeSectionIndex - 1, 0)]
        if (prev?.key) setActiveSection(prev.key)
    }

    const contactInfo = {
        phone: '+91 8639585257',
        email: 'contact@gettoindia.com',
    }

    // Which section each formik field lives in — used by handleReviewClick
    // to jump to the first invalid section on submit.
    const FIELD_SECTION_MAP = {
        storeName: 'basic', ownerName: 'basic', phoneNumber: 'basic', email: 'basic',
        address: 'location', state: 'location', city: 'location', postalcode: 'location',
        landmark: 'location', latitude: 'location', longitude: 'location', place_id: 'location',
        businessName: 'business', gst: 'business', pan: 'business',
        bankName: 'bank', accountType: 'bank', accountHolderName: 'bank',
        accountNumber: 'bank', reaccountNumber: 'bank', ifscCode: 'bank',
        storeTimings: 'timings',
    }

    const handleReviewClick = async () => {
        // Run yup validation and mark all fields touched so inline errors render
        const errors = await formik.validateForm()
        const touchedAll = Object.keys(formik.values).reduce((acc, k) => ({ ...acc, [k]: true }), {})
        formik.setTouched(touchedAll, false)

        const errorKeys = Object.keys(errors)
        const brandsMissing = !selectedBrands || selectedBrands.length === 0

        if (errorKeys.length === 0 && !brandsMissing) {
            formik.submitForm()
            return
        }

        // Pick the section to jump to. Brand-associated lives in 'basic'.
        // If a form field is invalid, prefer that field's section.
        let targetSection = 'basic'
        let toastMsg = 'Please fix the highlighted fields before submitting.'
        if (errorKeys.length > 0) {
            const firstKey = errorKeys[0]
            targetSection = FIELD_SECTION_MAP[firstKey] || 'basic'
            toastMsg = errors[firstKey] || toastMsg
        } else if (brandsMissing) {
            targetSection = 'basic'
            toastMsg = 'Please pick at least one brand.'
        }

        setActiveSection(targetSection)
        // Scroll the section into view (works for both mobile and desktop layouts)
        setTimeout(() => {
            const el = document.querySelector(`[data-section="${targetSection}"]`)
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 60)
        toast.error(toastMsg)
    }

    const toggleaccountNumberVisibility = (fieldName) => {
        setShowAccnumber((prev) => ({ ...prev, [fieldName]: !prev[fieldName] }))
    }


    const validationSchema = yup.object().shape({
        storeName: yup
            .string()
            .required('Store name is required')
            .min(2, 'Store name must be at least 2 characters')
            .max(100, 'Store name cannot exceed 100 characters'),

        // img_view: yup.string().required('Store image is required'),
        // pan_copy_view: yup.string().required('PAN copy image is required'),
        // gst_copy_view: yup.string().required('GST copy image is required'),
        // cancelled_cheque_view: yup.string().required('Cancelled cheque image is required'),

        ownerName: yup
            .string()
            .required('Owner name is required')
            .min(2, 'Owner name must be at least 2 characters')
            .max(50, 'Owner name cannot exceed 50 characters'),

        phoneNumber: yup
            .string()
            .matches(/^[1-9][0-9]{9}$/, 'Mobile number must be 10 digits, cannot start with 0, and contain only numbers')
            .required('Phone number is required'),

        email: yup
            .string()
            .email('Enter a valid email address')
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                'Enter a valid email address'
            )
            .required('Email is required')
            .max(100, 'Email cannot exceed 100 characters'),


        address: yup
            .string()
            .required('Address is required')
            .min(5, 'Address must be at least 5 characters')
            .max(200, 'Address cannot exceed 200 characters'),

        state: yup
            .string()
            .matches(/^[a-zA-Z\s]+$/, 'State can only contain letters and spaces')
            .required('State is required')
            .min(2, 'State must be at least 2 characters')
            .max(50, 'State cannot exceed 50 characters'),

        city: yup
            .string()
            .matches(/^[a-zA-Z\s]+$/, 'City can only contain letters and spaces')
            .required('City is required')
            .min(2, 'City must be at least 2 characters')
            .max(50, 'City cannot exceed 50 characters'),

        landmark: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .min(2, 'Landmark must be at least 2 characters')
            .max(100, 'Landmark cannot exceed 100 characters'),

        postalcode: yup
            .string()
            .matches(/^[1-9][0-9]{5}$/, 'Enter a valid 6-digit PinCode')
            .required('PinCode is required'),

        businessName: yup
            .string()
            .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Business name can only contain letters, numbers, spaces, and basic punctuation')
            // .required('Business name is required')
            .min(2, 'Business name must be at least 2 characters')
            .max(100, 'Business name cannot exceed 100 characters'),

        bankName: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Bank name can only contain letters, numbers, spaces, and basic punctuation')
            .min(2, 'Bank name must be at least 2 characters')
            .max(100, 'Bank name cannot exceed 100 characters'),

        accountType: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .matches(/^[a-zA-Z\s]+$/, 'Account type can only contain letters and spaces'),

        accountHolderName: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .matches(/^[a-zA-Z\s.'-]+$/, 'Account holder name can only contain letters, spaces, apostrophes, and hyphens')
            .min(2, 'Account holder name must be at least 2 characters')
            .max(50, 'Account holder name cannot exceed 50 characters'),

        accountNumber: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .matches(/^[0-9]+$/, 'Account number must contain only numbers')
            .min(9, 'Account number must be at least 9 digits')
            .max(18, 'Account number cannot exceed 18 digits'),


        reaccountNumber: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .oneOf([yup.ref('accountNumber'), null], 'Account numbers must match'),

        ifscCode: yup
            .string()
            .transform((val) => (val === '' ? undefined : val)),
            // .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter a valid IFSC Code (e.g., SBIN0000123)')

        gst: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            .length(15, 'GST must be 15 characters'),

        pan: yup
            .string()
            .transform((val) => (val === '' ? undefined : val))
            // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter a valid PAN number (e.g., ABCDE1234F)')
            .length(10, 'PAN must be 10 characters'),
    });

    const formik = useFormik({
        validateOnMount: true,
        initialValues: {
            storeName: '',
            image: '',
            pan_copy_image: '',
            gst_copy_image: '',
            cancelled_cheque_image: '',
            img_view: '',
            pan_copy_view: '',
            gst_copy_view: '',
            cancelled_cheque_view: '',
            ownerName: '',
            businessName: '',
            phoneNumber: '',
            email: '',
            address: '',
            state: '',
            city: '',
            postalcode: '',
            landmark: '',
            description: '',
            pan: '',
            gst: '',
            gstApplicable: false,
            bankName: '',
            accountType: '',
            accountHolderName: '',
            accountNumber: '',
            reaccountNumber: '',
            ifscCode: '',
            latitude: '',
            longitude: '',
            place_id: '',
            brandIds: [],

            storeTimings: [
                {
                    day: 'Monday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Tuesday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Wednesday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Thursday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Friday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Saturday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: true,
                },
                {
                    day: 'Sunday',
                    openingTime: '10:00',
                    closingTime: '22:00',
                    isActive: false,
                },
            ],
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true)
            if (values.image == '') {
                delete values.image
            }
            if (values.pan_copy_image == '') {
                delete values.pan_copy_image
            }
            if (values.gst_copy_image == '') {
                delete values.gst_copy_image
            }
            if (values.cancelled_cheque_image == '') {
                delete values.cancelled_cheque_image
            }
            delete values.img_view;
            delete values.pan_copy_view;
            delete values.gst_copy_view;
            delete values.cancelled_cheque_view;

            delete values.selectedBrands;

            const brandIds = selectedBrands.map(brand => brand.value);

            // delete values.reaccountNumber;
            const { reaccountNumber, ...rest } = values
            const data = {
                ...rest,
                brandIds // Add the array of brand IDs
            }

            try {
                if (id) {
                    updateManufacturer(data)((response) => {
                        if (response?.data?.statusCode == 200) {
                            setLoading(false)
                            setRefresh(!refresh)
                            resetForm()
                            toast.success('Store registered successfully')
                            setShowSuccessModal(true)
                        } else {
                            setLoading(false)
                            toast.error(response?.data?.message)
                        }
                    })
                } else {
                    registerVendor(data)((response) => {
                        if (response?.data?.statusCode == 200) {
                            setLoading(false)
                            if (bulkFormik?.values?.file) {
                                handlebulkSubmit(
                                    bulkFormik?.values?.file,
                                    response?.data?.data?.id
                                )
                            } else {
                                toast.success('store registered successfully')
                                setShowSuccessModal(true)
                            }
                            // handlebulkSubmit(bulkFormik.values.file, response?.data?.data?.id)
                            // bulkFormik.submitForm();
                        } else {
                            setLoading(false)
                            formik.setErrors({
                                email: response?.data?.message,
                            })
                            toast.error(response?.data?.message)
                        }
                    })
                }
            } catch (error) {
                console.error(error)

                setLoading(false)
            }
        },
    })

    const bulkFormik = useFormik({
        initialValues: {
            file: '',
            filename: '',
        },
        validationSchema: yup.object().shape({
            file: yup.string('').required('Required'),
        }),
        onSubmit: async (values, { resetForm }) => {
            setLoading(true)
            setBulkLoading(true)
            try {
                console.log(values)
                let formData = new FormData()
                formData.append('file', values.file)
                uploadBulkProducts(formData)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        setLoading(false)
                        setBulkLoading(false)
                        setBulkModal(false)
                        resetForm()
                        toast.success('Store Created Successfully')
                        setShowSuccessModal(true)
                    } else {
                        setLoading(false)
                        setBulkLoading(false)
                        toast.error(response?.data?.message)
                    }
                })
            } catch (error) {
                console.error(error)
                toast.error('something went wrong!, please try again', 'error')
                setLoading(false)
                setBulkLoading(false)
            }
        },
    })

    const handlebulkSubmit = (file, man_id) => {
        let formData = new FormData()
        formData.append('manufacturerId', man_id)
        formData.append('file', file)
        uploadBulkProducts(formData)((response) => {
            if (response && response?.data?.statusCode == 200) {
                setLoading(false)
                setBulkLoading(false)
                setBulkModal(false)
                toast.success('Store Created Successfully')
                setShowSuccessModal(true)
            } else {
                setLoading(false)
                setBulkLoading(false)
                toast.error(response?.data?.message)
            }
        })
    }

    const handleImageChange = async (e) => {
        const file = e?.target?.files[0];
        const inputId = e?.target?.id;

        if (!file) return;

        try {
            const response = await imageToBase64(URL.createObjectURL(file));
            const base64Image = 'data:image/jpeg;base64,' + response;

            // Map input IDs to the correct Formik value fields
            const fieldMap = {
                storeImage: { imageField: 'image', previewField: 'img_view' },
                panCopy: { imageField: 'pan_copy_image', previewField: 'pan_copy_view' }, // Changed to pan_copy_image
                gstCopy: { imageField: 'gst_copy_image', previewField: 'gst_copy_view' }, // Changed to gst_copy_image
                cancelledChequeCopy: { imageField: 'cancelled_cheque_image', previewField: 'cancelled_cheque_view' } // Changed to cancelled_cheque_image
            };

            const fieldConfig = fieldMap[inputId];

            if (fieldConfig) {
                formik.setValues({
                    ...formik.values,
                    [fieldConfig.imageField]: response, // This now sets the field Yup is validating
                    [fieldConfig.previewField]: base64Image,
                });
            }
        } catch (error) {
            console.error('Error processing image:', error);
        }
    };

    const statusActive = (timeid, active, index) => {
        console.log(timeid, active)
        if (id) {
            statusUpdateTiming({ timingId: timeid, isActive: !active })(
                (response) => {
                    if (response?.status == 200) {
                        setUpdate(!update)
                    } else {
                    }
                }
            )
        } else {
            const updatedStoreTimings = formik.values.storeTimings
            updatedStoreTimings[index].isActive = !active
            formik.setValues({
                ...formik.values,
                storeTimings: updatedStoreTimings,
            })
        }
    }

    const formatTime = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`)

        const hours = time.getHours().toString().padStart(2, '0')
        const minutes = time.getMinutes().toString().padStart(2, '0')

        return `${hours}:${minutes}`
    }

    const getManufacturer = async () => {
        getManufacturerDetails(id)(async (response) => {
            if (response?.data?.statusCode == 200) {
                const manufacturer = response?.data?.data[0]
                // Prefer VendorBrands if present, fallback to Brands
                let initialSelectedBrands = [];
                if (manufacturer.VendorBrands && manufacturer.VendorBrands.length > 0) {
                    initialSelectedBrands = manufacturer.VendorBrands
                        .map(vb => vb.Brand ? { value: vb.Brand.id, label: vb.Brand.name } : null)
                        .filter(Boolean);
                } else if (manufacturer.Brands && manufacturer.Brands.length > 0) {
                    initialSelectedBrands = manufacturer.Brands.map(brand => ({
                        value: brand.id,
                        label: brand.name,
                    }));
                }

                setSelectedBrands(initialSelectedBrands);


                formik.setValues((prevState) => ({
                    ...prevState,
                    id: id,
                    place_id: manufacturer?.place_id || '',
                    storeName: manufacturer?.storeName ? manufacturer?.storeName : '',
                    img_view: manufacturer?.VendorBankDetails[0]?.image ? manufacturer?.VendorBankDetails[0]?.image : '',
                    pan_copy_view: manufacturer?.VendorBankDetails[0]?.pan_copy ? manufacturer?.VendorBankDetails[0]?.pan_copy : '',
                    gst_copy_view: manufacturer?.VendorBankDetails[0]?.gst_copy ? manufacturer?.VendorBankDetails[0]?.gst_copy : '',
                    cancelled_cheque_view: manufacturer?.VendorBankDetails[0]?.cancelled_cheque_copy ? manufacturer?.VendorBankDetails[0]?.cancelled_cheque_copy : '',
                    ownerName: manufacturer?.ownerName ? manufacturer?.ownerName : '',
                    businessName: manufacturer?.VendorBankDetails[0]?.businessName ? manufacturer?.VendorBankDetails[0]?.businessName : '',
                    phoneNumber: manufacturer?.phoneNumber
                        ? manufacturer?.phoneNumber
                        : '',
                    gstApplicable: manufacturer?.gstApplicable
                        ? manufacturer?.gstApplicable
                        : false,
                    pan: manufacturer?.VendorBankDetails[0]?.pan
                        ? manufacturer?.VendorBankDetails[0]?.pan
                        : '',
                    gst: manufacturer?.VendorBankDetails[0]?.gst
                        ? manufacturer?.VendorBankDetails[0]?.gst
                        : '',
                    //   commission: manufacturer?.commission ?? '',

                    email: manufacturer?.email ? manufacturer?.email : '',
                    address: manufacturer?.address ? manufacturer?.address : '',
                    state: manufacturer?.state ? manufacturer?.state : '',
                    city: manufacturer?.city ? manufacturer?.city : '',
                    description: manufacturer?.description
                        ? manufacturer?.description
                        : '',
                    landmark: manufacturer?.landmark ? manufacturer?.landmark : '',
                    postalcode: manufacturer?.postalcode ? manufacturer?.postalcode : '',
                    latitude: manufacturer?.latitude ? manufacturer?.latitude : '',
                    longitude: manufacturer?.longitude ? manufacturer?.longitude : '',
                    bankName: manufacturer?.VendorBankDetails[0]?.bankName
                        ? manufacturer?.VendorBankDetails[0]?.bankName
                        : '',
                    accountType: manufacturer?.VendorBankDetails[0]?.accountType
                        ? manufacturer?.VendorBankDetails[0]?.accountType
                        : '',
                    accountHolderName: manufacturer?.VendorBankDetails[0]
                        ?.accountHolderName
                        ? manufacturer?.VendorBankDetails[0]?.accountHolderName
                        : '',
                    accountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
                        ? manufacturer?.VendorBankDetails[0]?.accountNumber
                        : '',
                    reaccountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
                        ? manufacturer?.VendorBankDetails[0]?.accountNumber
                        : '',
                    ifscCode: manufacturer?.VendorBankDetails[0]?.ifscCode
                        ? manufacturer?.VendorBankDetails[0]?.ifscCode
                        : '',
                    storeTimings: manufacturer?.StoreTimings
                        ? manufacturer.StoreTimings
                        : prevState.storeTimings,

                    selectedBrands: initialSelectedBrands,
                    brandIds: initialSelectedBrands.map(brand => brand.value),

                }))


                // Set the GooglePlacesAutocomplete value for edit mode
                // In getManufacturer function, update the value setting:
                setValue(
                    manufacturer?.place_id && manufacturer?.address
                        ? {
                            label: manufacturer.address,
                            value: {
                                place_id: manufacturer.place_id,
                                description: manufacturer.address
                            }
                        }
                        : null
                )

                // Set the map center with latitude and longitude
                setMapCenter({
                    lat: manufacturer?.latitude ?? 0,
                    lng: manufacturer?.longitude ?? 0,
                })
                setStore(manufacturer)
                setLoading(false)
            } else {
                setStore([])
                setLoading(false)
            }
        })
    }

    const handleBulkFileChange = async (e) => {
        const file = e?.target?.files[0]
        console.log(file, 'bulk')
        const supportedFormats = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ]

        if (file && !supportedFormats.includes(file.type)) {
            toast.error('Unsupported file format. Please upload an Excel file.')
            return
        }

        bulkFormik.setValues({
            ...bulkFormik.values,
            file: file,
            filename: file?.name,
        })
    }

    const downloadSampleFile = () => {
        const a = document.createElement('a')
        a.href = sampleFile
        a.download = `sample-sheet.xlsx` // Specify the filename here
        document.body.appendChild(a)
        a.click()
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        const trimmedValue = value.replace(/^\s+/, '')
        formik.setFieldValue(name, trimmedValue)
    }

    useEffect(() => {
        if (id) {
            setLoading(true)
            getManufacturer()
        }
    }, [update, id])

    useEffect(() => {
        console.log("Form errors:", formik.errors);
        console.log("Form touched:", formik.touched);
        console.log("Form isValid:", formik.isValid);
    }, [formik.errors, formik.touched, formik.isValid]);

    useEffect(() => {
        const existingScript = document.getElementById('googleMaps')
        if (!existingScript) {
            const script = document.createElement('script')
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`
            script.id = 'googleMaps'
            document.body.appendChild(script)
            script.onload = () => setScript(true)
        } else {
            setScript(true)
        }
    }, [GOOGLE_MAP_API_KEY])

    const changeValue = async (value) => {
        if (!value?.value?.place_id) {
            setValue(null)
            return
        }
        try {
            const results = await geocodeByPlaceId(value.value.place_id)
            const location = results[0]
            const { lat, lng } = await getLatLng(location)

            setMapCenter({ lat, lng })
            formik.setFieldValue('latitude', lat)
            formik.setFieldValue('longitude', lng)
            formik.setFieldValue('place_id', value.value.place_id)

            // Extract address components
            const addressComponents = location?.address_components || []
            const address = location?.formatted_address || ''

            const getComponent = (type) =>
                addressComponents.find((component) => component.types.includes(type))
                    ?.long_name || ''

            const state = getComponent('administrative_area_level_1')
            const city =
                getComponent('locality') || getComponent('administrative_area_level_2')
            const postalcode = getComponent('postal_code')

            formik.setFieldValue('address', address)
            formik.setFieldValue('state', state)
            formik.setFieldValue('city', city)
            formik.setFieldValue('postalcode', postalcode)
        } catch (error) {
            console.error('Error fetching location coordinates:', error)
        } finally {
            // Clear the search input so the user can search again without deleting the pick
            setValue(null)
        }
    }

    const handleMapClick = ({ lat, long }) => {
        console.log(lat, long)

        mapCenter({ lat, long })
        formik.setFieldValue('latitude', lat)
        formik.setFieldValue('longitude', long)
    }

    const [locatingUser, setLocatingUser] = useState(false)
    const handleUseCurrentLocation = () => {
        if (!('geolocation' in navigator)) {
            toast.error('Geolocation is not supported by this browser')
            return
        }
        if (!GOOGLE_MAP_API_KEY) {
            toast.error('Google Maps key is missing')
            return
        }
        setLocatingUser(true)
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude: lat, longitude: lng } = position.coords
                try {
                    const res = await fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_API_KEY}`
                    )
                    const data = await res.json()
                    if (data.status !== 'OK' || !data.results?.length) {
                        throw new Error(data.error_message || 'No address found for your location')
                    }
                    const result = data.results[0]
                    const addressComponents = result.address_components || []
                    const address = result.formatted_address || ''
                    const getComponent = (type) =>
                        addressComponents.find((c) => c.types.includes(type))?.long_name || ''

                    const state = getComponent('administrative_area_level_1')
                    const city =
                        getComponent('locality') || getComponent('administrative_area_level_2')
                    const postalcode = getComponent('postal_code')

                    setMapCenter({ lat, lng })
                    formik.setFieldValue('latitude', lat)
                    formik.setFieldValue('longitude', lng)
                    formik.setFieldValue('place_id', result.place_id || '')
                    formik.setFieldValue('address', address)
                    formik.setFieldValue('state', state)
                    formik.setFieldValue('city', city)
                    formik.setFieldValue('postalcode', postalcode)
                    setValue(null)
                    toast.success('Location filled from your current position')
                } catch (err) {
                    console.error('Reverse geocoding failed', err)
                    toast.error(err.message || 'Could not resolve your address')
                } finally {
                    setLocatingUser(false)
                }
            },
            (err) => {
                setLocatingUser(false)
                if (err.code === err.PERMISSION_DENIED) {
                    toast.error('Location permission denied. Please allow location access.')
                } else if (err.code === err.POSITION_UNAVAILABLE) {
                    toast.error('Location unavailable. Please try again.')
                } else if (err.code === err.TIMEOUT) {
                    toast.error('Location request timed out. Please try again.')
                } else {
                    toast.error('Unable to fetch your current location')
                }
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
        )
    }

    useEffect(() => {
        const inputs = document.getElementsByTagName('input')
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].setAttribute('autocomplete', 'one-time-code')
        }
        fetchBrands();
    }, [])


    // Fetch all brands once (up to 1000) — search then filters locally instead of hitting the API
    const fetchBrands = () => {
        return new Promise((resolve) => {
            getBrandListing({ page: 1, pageSize: 1000, search: '' })(response => {
                if (response?.statusCode === 200) {
                    const results = (response?.data || []).map(item => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setBrands(results);
                    setHasMore(false);
                    resolve(results);
                } else {
                    setHasMore(false);
                    resolve([]);
                }
            });
        });
    };

    const loadOptionsBrands = (inputValue) => {
        const available = brands.filter(
            (brand) => !selectedBrands.some((selected) => selected.value === brand.value)
        );
        if (!inputValue) return Promise.resolve(available);
        const q = inputValue.toLowerCase();
        return Promise.resolve(
            available.filter((brand) => brand.label.toLowerCase().includes(q))
        );
    };

    const handleMenuScrollToBottom = () => {
        // No-op: all brands are fetched up front (pageSize: 1000)
        if (hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
        }
    };

    const onBrandChange = (selectedOptions) => {
        setSelectedBrands(selectedOptions);
        setBrandError(false); // Clear error on change
        formik.setValues({
            ...formik.values,
            selectedBrands: selectedOptions,
            brandIds: selectedOptions.map(brand => brand.value),
        });
    };


    const removeBrand = (brandToRemove) => {
        const updatedBrands = selectedBrands.filter(brand => brand.value !== brandToRemove.value);
        setSelectedBrands(updatedBrands);

        // Update formik values
        formik.setValues({
            ...formik.values,
            selectedBrands: updatedBrands,
            brandIds: updatedBrands.map(brand => brand.value),
        });
    };


    return (
        <div className="vendor-register-wrapper">
            {/* Top Nav Bar */}
            <div className="vendor-register-topbar">
                <div className="vendor-topbar-inner">
                    <button
                        type="button"
                        className="vendor-back-btn"
                        onClick={() => navigate('/login')}
                    >
                        <FiArrowLeft size={18} />
                        <span>Back to Login</span>
                    </button>
                    <div className="vendor-topbar-actions">
                        <button
                            type="button"
                            className="vendor-contact-btn"
                            onClick={() => setShowContactModal(true)}
                        >
                            <FiHeadphones size={16} />
                            <span>Contact Us</span>
                        </button>
                        <Button
                            type="button"
                            onClick={handleReviewClick}
                            disabled={loading}
                            className="vendor-submit-btn vendor-submit-header"
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    Processing...
                                </>
                            ) : (
                                <>
                                    <FiSend size={14} className="me-2" />
                                    Submit for Review
                                </>
                            )}
                        </Button>
                    </div>
                </div>
            </div>

            <div className="vendor-register-container">
            <Form id="vendor-register-form" onSubmit={formik.handleSubmit}>
                {/* Section tabs */}
                <div className="vfp-tabs" role="tablist">
                    {VFP_SECTIONS.map((s) => {
                        const isActive = activeSection === s.key
                        return (
                            <button
                                key={s.key}
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                className={`vfp-tab ${isActive ? 'is-active' : ''}`}
                                onClick={() => setActiveSection(s.key)}
                            >
                                <span className="vfp-tab-label-full">{s.label}</span>
                                <span className="vfp-tab-label-short">{s.shortLabel}</span>
                            </button>
                        )
                    })}
                </div>

                {/* Basic Information Card */}
                <Card data-section="basic" className={`vendor-card mb-4 vfp-section ${activeSection === 'basic' ? 'is-active' : ''}`}>
                    <Card.Header className="vendor-card-header">
                        <div className="vendor-card-header-icon">
                            <FiHome strokeWidth={1.7} />
                        </div>
                        <div>
                            <div className="vendor-card-header-title">Store Information</div>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-4">
                        <Row>

                            <Row>
                                {/* Left Side - Form Fields (8 columns) */}
                                <Col md={8}>
                                    <Row>
                                        {/* Store Name - 6 columns on large screens, 12 on smaller */}
                                        <Col md={6} lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label className="fw-semibold">Store Name *</Form.Label>
                                                <Form.Control
                                                    type="text"n                                                    name="storeName"
                                                    value={formik.values?.storeName}
                                                    onChange={handleInputChange}
                                                    isInvalid={formik.touched.storeName && !!formik.errors.storeName}
                                                    className="rounded-input"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {formik.errors.storeName}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                        {/* Owner Name - 6 columns on large screens, 12 on smaller */}
                                        <Col md={6} lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label className="fw-semibold">Owner Name *</Form.Label>
                                                <Form.Control
                                                    type="text"n                                                    name="ownerName"
                                                    value={formik.values?.ownerName}
                                                    onChange={handleInputChange}
                                                    isInvalid={formik.touched.ownerName && !!formik.errors.ownerName}
                                                    className="rounded-input"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {formik.errors.ownerName}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Brands associated *</Form.Label>
                                                <AsyncSelect
                                                    isMulti
                                                    loadOptions={loadOptionsBrands}
                                                    defaultOptions={brands}
                                                    classNamePrefix="select"
                                                    isClearable={true}
                                                    onChange={onBrandChange}
                                                    value={selectedBrands}
                                                    onMenuScrollToBottom={handleMenuScrollToBottom}
                                                    placeholder="Search for brands"
                                                    noOptionsMessage={() => (
                                                        <div className="brand-noresult">
                                                            <div className="brand-noresult-icon" aria-hidden="true">🔎</div>
                                                            <div className="brand-noresult-title">No brands found</div>
                                                            <div className="brand-noresult-sub">Can't find your brand? Register it now.</div>
                                                            <button
                                                                type="button"
                                                                className="brand-noresult-btn"
                                                                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation() }}
                                                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); openRegisterBrandModal() }}
                                                            >
                                                                <FiPlus size={12} />
                                                                Register brand
                                                            </button>
                                                        </div>
                                                    )}
                                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                    menuPosition="fixed"
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                            width: 260,
                                                            maxWidth: '90vw',
                                                            fontSize: 11,
                                                            borderRadius: 8,
                                                            boxShadow: '0 8px 24px rgba(15,23,42,0.10)',
                                                        }),
                                                        menuList: (base) => ({
                                                            ...base,
                                                            maxHeight: 220,
                                                            paddingTop: 4,
                                                            paddingBottom: 4,
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: 11,
                                                            padding: '6px 10px',
                                                            backgroundColor: state.isFocused ? 'rgba(40,141,157,0.10)' : '#fff',
                                                            color: '#0f172a',
                                                            cursor: 'pointer',
                                                        }),
                                                        noOptionsMessage: (base) => ({
                                                            ...base,
                                                            fontSize: 11,
                                                            padding: '8px 10px',
                                                        }),
                                                        loadingMessage: (base) => ({
                                                            ...base,
                                                            fontSize: 11,
                                                            padding: '8px 10px',
                                                        }),
                                                        control: (base) => ({
                                                            ...base,
                                                            border: "1px solid #ced4da",
                                                            borderRadius: "8px",
                                                            minHeight: "34px",
                                                            fontSize: "12px",
                                                        }),
                                                        valueContainer: (base) => ({
                                                            ...base,
                                                            display: "flex",
                                                            flexWrap: "nowrap",
                                                            overflowX: "auto",
                                                            overflowY: "hidden",
                                                            scrollbarWidth: "none",
                                                            msOverflowStyle: "none",
                                                            "::-webkit-scrollbar": { display: "none" },
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            minWidth: "2px",
                                                            margin: 0,
                                                            padding: 0,
                                                            flexShrink: 1,
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            color: "#94a3b8",
                                                            fontSize: "11.5px",
                                                            fontWeight: 400,
                                                        }),
                                                        multiValue: (base) => ({
                                                            ...base,
                                                            backgroundColor: "#288d9dff",
                                                            color: "white",
                                                            borderRadius: "12px",
                                                            padding: "0 4px",
                                                            flexShrink: 0,
                                                        }),
                                                        multiValueLabel: (base) => ({
                                                            ...base,
                                                            color: "white",
                                                            fontSize: "11px",
                                                        }),
                                                        multiValueRemove: (base) => ({
                                                            ...base,
                                                            color: "white",
                                                            ':hover': {
                                                                backgroundColor: "#288d9dff",
                                                                color: "white",
                                                            },
                                                        }),
                                                    }}
                                                />
                                                {(brandError || (selectedBrands.length === 0 && formik.submitCount > 0)) && (
                                                    <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "10px", marginTop: '4px' }}>
                                                        At least one brand is required
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Phone Number - 6 columns on large screens, 12 on smaller */}
                                        <Col md={6} lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Phone Number *</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="phoneNumber"
                                                    value={formik.values?.phoneNumber}
                                                    onChange={formik.handleChange}
                                                    isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                                                    maxLength={10}
                                                    className="rounded-input"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {formik.errors.phoneNumber}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                        {/* Email Address - 6 columns on large screens, 12 on smaller */}
                                        <Col md={6} lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Email Address *</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={formik.values?.email}
                                                    onChange={formik.handleChange}
                                                    isInvalid={formik.touched.email && !!formik.errors.email}
                                                    className="rounded-input"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {formik.errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                        {/* Description - full width under brands */}
                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Description</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="description"
                                                    value={formik.values?.description}
                                                    onChange={formik.handleChange}
                                                    className="rounded-input"
                                                />
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                </Col>

                                {/* Right Side - Image Upload (4 columns) */}
                                <Col md={4} className="d-flex">
                                    <Form.Group className="mb-3 d-flex flex-column w-100">
                                        <Form.Label className="fw-semibold">Store Image</Form.Label>
                                        <div
                                            className="image-upload-container position-relative rounded p-2 text-center flex-grow-1"
                                            onClick={() => document.getElementById('storeImage').click()}
                                            style={{
                                                cursor: 'pointer',
                                                minHeight: '230px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '2px dashed #d1d1d1ff',
                                                transition: 'all 0.3s ease',
                                                overflow: 'hidden',
                                                borderRadius: '16px',
                                            }}
                                        >
                                            {formik.values.img_view ? (
                                                <>
                                                    <img
                                                        src={formik.values.img_view}
                                                        alt="Store"
                                                        className="img-fluid h-150 w-100"
                                                        style={{
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                    {/* Hover Overlay */}
                                                    <div
                                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                                                        style={{
                                                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                            opacity: 0,
                                                            transition: 'opacity 0.3s ease',
                                                            color: 'white'
                                                        }}
                                                        onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                                                    >
                                                        <FiUploadCloud size={24} className="mb-1" />
                                                        <small>Change image</small>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <FiUploadCloud size={28} className="text-muted mb-2" />
                                                    <p className="text-muted mb-1 small">Click to upload store image</p>

                                                </>
                                            )}
                                        </div>
                                        <Form.Control
                                            id="storeImage"
                                            name="storeImage"
                                            type="file"
                                            onChange={handleImageChange}
                                            isInvalid={formik.touched.image && formik.errors.image}
                                            style={{ display: 'none' }}
                                            accept="image/*"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {formik.errors.image}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                            </Row>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Location Information Card */}
                <Card data-section="location" className={`vendor-card mb-4 vfp-section ${activeSection === 'location' ? 'is-active' : ''}`}>
                    <Card.Header className="vendor-card-header vendor-card-header-split">
                        <div className="d-flex align-items-center gap-3">
                            <div className="vendor-card-header-icon">
                                <FiMapPin strokeWidth={1.7} />
                            </div>
                            <div className="vendor-card-header-title">Location Information</div>
                        </div>
                        <button
                            type="button"
                            className="use-current-location-btn"
                            onClick={handleUseCurrentLocation}
                            disabled={locatingUser}
                        >
                            {locatingUser ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Locating...
                                </>
                            ) : (
                                <>
                                    <FiCrosshair size={12} />
                                    Use current location
                                </>
                            )}
                        </button>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Row>
                            {/* Left Column - Search + Location Form Fields */}
                            <Col md={12} lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Search Location</Form.Label>
                                    {script && (
                                        <GooglePlacesAutocomplete
                                            selectProps={{
                                                placeholder: '',
                                                value,
                                                onChange: changeValue,
                                                noOptionsMessage: () => 'No locations found',
                                                styles: {
                                                    control: (base) => ({
                                                        ...base,
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '6px',
                                                        padding: '0 6px',
                                                        minHeight: '30px',
                                                        height: '30px',
                                                        fontSize: '11.5px',
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: '0 4px',
                                                        height: '28px',
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0,
                                                        fontSize: '11.5px',
                                                        color: '#0f172a',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '11.5px',
                                                        color: '#0f172a',
                                                        fontWeight: 500,
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '28px',
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: '#6c757d',
                                                        fontSize: '11.5px',
                                                    }),
                                                },
                                            }}
                                        />
                                    )}
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Address *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="address"
                                        value={formik.values?.address}
                                        onChange={handleInputChange}
                                        isInvalid={formik.touched.address && !!formik.errors.address}
                                        className="rounded-input"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.address}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">State *</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="state"
                                                value={formik.values?.state}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.state && !!formik.errors.state}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.state}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">City *</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="city"
                                                value={formik.values?.city}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.city && !!formik.errors.city}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.city}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Pincode *</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="postalcode"
                                                value={formik.values?.postalcode}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.postalcode && !!formik.errors.postalcode}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.postalcode}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Landmark</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="landmark"
                                                value={formik.values?.landmark}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.landmark && !!formik.errors.landmark}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.landmark}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>

                            {/* Right Column - Map */}
                            <Col md={12} lg={6} className="vfp-map-col">
                                <Form.Label className="fw-semibold">Location Map</Form.Label>
                                <div
                                    className="vfp-map-box"
                                    style={{
                                        width: '100%',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        border: '1px solid #dee2e6',
                                    }}
                                >
                                    {script && (
                                        <GoogleMap
                                            bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
                                            defaultZoom={15}
                                            center={mapCenter}
                                            yesIWantToUseGoogleMapApiInternals
                                        >
                                            <div
                                                lat={mapCenter.lat}
                                                lng={mapCenter.lng}
                                                style={{ color: 'red', fontSize: '32px' }}
                                            >
                                                <FaMapMarkerAlt className="marker_icon bounce" />
                                            </div>
                                        </GoogleMap>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>



                {/* Business Details Card */}
                <Card data-section="business" className={`vendor-card mb-4 vfp-section ${activeSection === 'business' ? 'is-active' : ''}`}>
                    <Card.Header className="vendor-card-header">
                        <div className="vendor-card-header-icon">
                            <FiBriefcase strokeWidth={1.7} />
                        </div>
                        <div>
                            <div className="vendor-card-header-title">Business Details</div>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Row>
                            {/* Left side - Business Information (narrower on desktop) */}
                            <Col md={12} lg={5}>
                                <Row>

                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Business name on GST Document</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="businessName"
                                                value={formik.values?.businessName}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.businessName && !!formik.errors.businessName}
                                                // maxLength={15}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.businessName}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>


                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">GST Number</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="gst"
                                                value={formik.values?.gst}
                                                onChange={handleInputChange}
                                                isInvalid={formik.touched.gst && !!formik.errors.gst}
                                                maxLength={15}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.gst}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">PAN Number</Form.Label>
                                            <Form.Control
                                                type="text"n                                                name="pan"
                                                value={formik.values?.pan}
                                                onChange={formik.handleChange}
                                                isInvalid={formik.touched.pan && !!formik.errors.pan}
                                                maxLength={10}
                                                className="rounded-input"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.pan}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>


                                </Row>
                            </Col>

                            {/* Right side - Document Uploads (wider on desktop, all 3 in a row) */}
                            <Col md={12} lg={7}>
                                <Row>
                                    {/* PAN Copy Upload */}
                                    <Col xs={12} md={4} className="mb-4">
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-semibold">PAN Copy</Form.Label>
                                            <div
                                                className="image-upload-container position-relative rounded p-2 text-center"
                                                onClick={() => document.getElementById('panCopy').click()}
                                                style={{
                                                    cursor: 'pointer',
                                                    height: '150px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '2px dashed #d1d1d1ff',
                                                    transition: 'all 0.3s ease',
                                                    overflow: 'hidden',
                                                    borderRadius: '16px',
                                                }}
                                            >
                                                {formik.values.pan_copy_view ? (
                                                    <>
                                                        <img
                                                            src={formik.values.pan_copy_view}
                                                            alt="PAN Copy"
                                                            className="img-fluid h-100 w-100"
                                                            style={{
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        {/* Hover Overlay */}
                                                        <div
                                                            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                opacity: 0,
                                                                transition: 'opacity 0.3s ease',
                                                                color: 'white'
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                                                        >
                                                            <FiUploadCloud size={20} className="mb-1" />
                                                            <small>Change PAN copy</small>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FiUploadCloud size={24} className="text-muted mb-2" />
                                                        <p className="text-muted mb-1 small">Click to upload PAN copy</p>

                                                    </>
                                                )}
                                            </div>
                                            <Form.Control
                                                id="panCopy"
                                                name="panCopy"

                                                type="file"

                                                onChange={handleImageChange}
                                                isInvalid={formik.touched.pan_copy && formik.errors.pan_copy}
                                                style={{ display: 'none' }}
                                                accept="image/*"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.pan_copy}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    {/* GST Copy Upload */}
                                    <Col xs={12} md={4} className="mb-4">
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-semibold">GST Copy</Form.Label>
                                            <div
                                                className="image-upload-container position-relative rounded p-2 text-center"
                                                onClick={() => document.getElementById('gstCopy').click()}
                                                style={{
                                                    cursor: 'pointer',
                                                    height: '150px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '2px dashed #d1d1d1ff',
                                                    transition: 'all 0.3s ease',
                                                    overflow: 'hidden',
                                                    borderRadius: '16px',
                                                }}
                                            >
                                                {formik.values.gst_copy_view ? (
                                                    <>
                                                        <img
                                                            src={formik.values.gst_copy_view}
                                                            alt="GST Copy"
                                                            className="img-fluid h-100 w-100"
                                                            style={{
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        {/* Hover Overlay */}
                                                        <div
                                                            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                opacity: 0,
                                                                transition: 'opacity 0.3s ease',
                                                                color: 'white'
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                                                        >
                                                            <FiUploadCloud size={20} className="mb-1" />
                                                            <small>Change GST copy</small>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FiUploadCloud size={24} className="text-muted mb-2" />
                                                        <p className="text-muted mb-1 small">Click to upload GST copy</p>

                                                    </>
                                                )}
                                            </div>
                                            <Form.Control
                                                id="gstCopy"
                                                name="gstCopy"
                                                type="file"

                                                onChange={handleImageChange}
                                                isInvalid={formik.touched.gst_copy && formik.errors.gst_copy}
                                                style={{ display: 'none' }}
                                                accept="image/*"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.gst_copy}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>


                                    {/* Cancelled Cheque Copy Upload */}
                                    <Col xs={12} md={4} className="mb-4">
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-semibold">Cancelled cheque copy</Form.Label>
                                            <div
                                                className="image-upload-container position-relative rounded p-2 text-center"
                                                onClick={() => document.getElementById('cancelledChequeCopy').click()}
                                                style={{
                                                    cursor: 'pointer',
                                                    height: '150px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '2px dashed #d1d1d1ff',
                                                    transition: 'all 0.3s ease',
                                                    overflow: 'hidden',
                                                    borderRadius: '16px',
                                                }}
                                            >
                                                {formik.values.cancelled_cheque_view ? (
                                                    <>
                                                        <img
                                                            src={formik.values.cancelled_cheque_view}
                                                            alt="Cancelled Cheque"
                                                            className="img-fluid h-100 w-100"
                                                            style={{
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        {/* Hover Overlay */}
                                                        <div
                                                            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                opacity: 0,
                                                                transition: 'opacity 0.3s ease',
                                                                color: 'white'
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                                                        >
                                                            <FiUploadCloud size={20} className="mb-1" />
                                                            <small>Change Cancelled Cheque copy</small>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FiUploadCloud size={24} className="text-muted mb-2" />
                                                        <p className="text-muted mb-1 small">Click to upload Cancelled Cheque copy</p>

                                                    </>
                                                )}
                                            </div>
                                            <Form.Control
                                                id="cancelledChequeCopy"
                                                name="cancelledChequeCopy"
                                                type="file"

                                                onChange={handleImageChange}
                                                isInvalid={formik.touched.cancelled_cheque_copy && formik.errors.cancelled_cheque_copy}
                                                style={{ display: 'none' }}
                                                accept="image/*"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.cancelled_cheque_copy}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Bank Details Card */}
                <Card data-section="bank" className={`vendor-card mb-4 vfp-section ${activeSection === 'bank' ? 'is-active' : ''}`}>
                    <Card.Header className="vendor-card-header">
                        <div className="vendor-card-header-icon">
                            <FiCreditCard strokeWidth={1.7} />
                        </div>
                        <div>
                            <div className="vendor-card-header-title">Bank Details</div>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Row>
                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Bank Name</Form.Label>
                                    <Form.Control
                                        type="text"n                                        name="bankName"
                                        value={formik.values?.bankName}
                                        onChange={handleInputChange}
                                        isInvalid={formik.touched.bankName && !!formik.errors.bankName}
                                        className="rounded-input"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.bankName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Account Type</Form.Label>
                                    <Form.Select
                                        name="accountType"
                                        value={formik.values.accountType}
                                        onChange={formik.handleChange}
                                        isInvalid={formik.touched.accountType && !!formik.errors.accountType}
                                        className="rounded-input"
                                    >
                                        <option value="">Select account type</option>
                                        <option value="Savings">Savings</option>
                                        <option value="Current">Current</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.accountType}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Account Holder Name</Form.Label>
                                    <Form.Control
                                        type="text"n                                        name="accountHolderName"
                                        value={formik.values?.accountHolderName}
                                        onChange={formik.handleChange}
                                        isInvalid={formik.touched.accountHolderName && !!formik.errors.accountHolderName}
                                        className="rounded-input"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.accountHolderName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Account Number</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type={showaccnumber.accountNumber ? "text" : "password"}n                                            name="accountNumber"
                                            value={formik.values?.accountNumber}
                                            onChange={formik.handleChange}
                                            isInvalid={formik.touched.accountNumber && !!formik.errors.accountNumber}
                                            className="rounded-input pe-5"
                                        />
                                        <span
                                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => toggleaccountNumberVisibility("accountNumber")}
                                        >
                                            {showaccnumber.accountNumber ? <BsEye /> : <BsEyeSlash />}
                                        </span>
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.accountNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Re-enter Account Number</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type={showaccnumber.reaccountNumber ? "text" : "password"}n                                            name="reaccountNumber"
                                            value={formik.values?.reaccountNumber}
                                            onChange={formik.handleChange}
                                            isInvalid={formik.touched.reaccountNumber && !!formik.errors.reaccountNumber}
                                            className="rounded-input pe-5"
                                        />
                                        <span
                                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => toggleaccountNumberVisibility("reaccountNumber")}
                                        >
                                            {showaccnumber.reaccountNumber ? <BsEye /> : <BsEyeSlash />}
                                        </span>
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.reaccountNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">IFSC Code</Form.Label>
                                    <Form.Control
                                        type="text"n                                        name="ifscCode"
                                        value={formik.values?.ifscCode}
                                        onChange={formik.handleChange}
                                        isInvalid={formik.touched.ifscCode && !!formik.errors.ifscCode}
                                        maxLength={11}
                                        className="rounded-input"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.ifscCode}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>


                {/* Store Timings Card - Table Layout */}
                <Card data-section="timings" className={`vendor-card mb-4 vfp-section ${activeSection === 'timings' ? 'is-active' : ''}`}>
                    <Card.Header className="vendor-card-header vendor-card-header-split">
                        <div className="d-flex align-items-center gap-3">
                            <div className="vendor-card-header-icon">
                                <FiClock strokeWidth={1.7} />
                            </div>
                            <div>
                                <div className="vendor-card-header-title">Store Timings</div>
                            </div>
                        </div>

                        <Button
                            onClick={() => {
                                const mondayTiming = formik.values.storeTimings.find(t => t.day === "Monday");
                                if (mondayTiming) {
                                    const updatedTimings = formik.values.storeTimings.map(timing =>
                                        timing.day !== "Monday"
                                            ? {
                                                ...timing,
                                                openingTime: mondayTiming.openingTime,
                                                closingTime: mondayTiming.closingTime,
                                            }
                                            : timing
                                    );
                                    formik.setFieldValue("storeTimings", updatedTimings);
                                }
                            }}
                            variant="outline-dark"
                            className="vendor-apply-monday-btn"
                        >
                            Apply Monday timing to all
                        </Button>

                    </Card.Header>

                    <Card.Body className="p-4">
                        {/* Desktop table */}
                        <div className="vfp-timings-table-wrap">
                            <table className="vfp-timings-table">
                                <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th>Status</th>
                                        <th>Opening Time</th>
                                        <th>Closing Time</th>
                                        <th className="text-end">Toggle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formik.values.storeTimings.map((timing, index) => (
                                        <tr key={index} className={`vfp-timings-row ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                                            <td className="vfp-day-cell">{timing.day}</td>
                                            <td>
                                                <span className={`vfp-status-chip ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                                                    <span className="vfp-status-dot" />
                                                    {timing?.isActive ? 'Open' : 'Closed'}
                                                </span>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="time"
                                                    name={`storeTimings.${index}.openingTime`}
                                                    value={formik.values.storeTimings[index].openingTime}
                                                    onChange={formik.handleChange}
                                                    disabled={!timing?.isActive}
                                                    className="vfp-time-input"
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="time"
                                                    name={`storeTimings.${index}.closingTime`}
                                                    value={formik.values.storeTimings[index].closingTime}
                                                    onChange={formik.handleChange}
                                                    disabled={!timing?.isActive}
                                                    className="vfp-time-input"
                                                />
                                            </td>
                                            <td className="text-end">
                                                <Switch
                                                    size="small"
                                                    id={`custom-switch-${index}`}
                                                    checked={timing?.isActive}
                                                    onChange={() => statusActive(timing?.id, timing?.isActive, index)}
                                                    className="vfp-timings-switch"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Mobile cards */}
                        <div className="vfp-timings-cards">
                            {formik.values.storeTimings.map((timing, index) => (
                                <div key={index} className={`vfp-timing-card ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                                    <div className="vfp-timing-card-top">
                                        <div className="vfp-timing-day">
                                            <span className="vfp-day-name">{timing.day}</span>
                                            <span className={`vfp-status-chip ${timing?.isActive ? 'is-open' : 'is-closed'}`}>
                                                <span className="vfp-status-dot" />
                                                {timing?.isActive ? 'Open' : 'Closed'}
                                            </span>
                                        </div>
                                        <Switch
                                            size="small"
                                            id={`custom-switch-mobile-${index}`}
                                            checked={timing?.isActive}
                                            onChange={() => statusActive(timing?.id, timing?.isActive, index)}
                                            className="vfp-timings-switch"
                                        />
                                    </div>
                                    <div className="vfp-timing-card-times">
                                        <div className="vfp-timing-field">
                                            <label className="vfp-timing-label">Opening</label>
                                            <Form.Control
                                                type="time"
                                                name={`storeTimings.${index}.openingTime`}
                                                value={formik.values.storeTimings[index].openingTime}
                                                onChange={formik.handleChange}
                                                disabled={!timing?.isActive}
                                                className="vfp-time-input"
                                            />
                                        </div>
                                        <div className="vfp-timing-field">
                                            <label className="vfp-timing-label">Closing</label>
                                            <Form.Control
                                                type="time"
                                                name={`storeTimings.${index}.closingTime`}
                                                value={formik.values.storeTimings[index].closingTime}
                                                onChange={formik.handleChange}
                                                disabled={!timing?.isActive}
                                                className="vfp-time-input"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card.Body>
                </Card>

                {/* Action Buttons - mobile only (desktop shows Submit in the header) */}
                <div className="vendor-action-bar vendor-action-bar-mobile">
                    <Button
                        type="button"
                        onClick={handleReviewClick}
                        disabled={loading}
                        className="vendor-submit-btn"
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Processing...
                            </>
                        ) : (
                            <>
                                <FiSend size={14} className="me-2" />
                                Submit for Review
                            </>
                        )}
                    </Button>
                </div>
            </Form>
            </div>

            {/* Fixed bottom secure note (desktop + mobile) */}
            <div className="vendor-secure-note" role="note">
                <BsShieldCheck size={14} />
                <span className="vendor-secure-note-full">Your details are encrypted and never shared. We only use them to verify your store.</span>
                <span className="vendor-secure-note-short">Your details are encrypted &amp; never shared.</span>
            </div>

            <style jsx>{`
                .vendor-register-wrapper {
                    min-height: 100vh;
                    background: linear-gradient(180deg, #f6f8fb 0%, #eef2f7 100%);
                }

                /* ===== Section tabs (underline style — mirrors create-vendors) ===== */
                .vendor-register-wrapper .vfp-tabs {
                    display: flex;
                    align-items: center;
                    gap: 0;
                    margin: 0 0 16px 0;
                    border-bottom: 1px solid #e2e8f0;
                    overflow-x: auto;
                    scrollbar-width: none;
                    background: transparent;
                    padding: 0;
                    box-shadow: none;
                    border-radius: 0;
                }
                .vendor-register-wrapper .vfp-tabs::-webkit-scrollbar { display: none; }
                .vendor-register-wrapper .vfp-tab {
                    position: relative;
                    padding: 10px 18px;
                    border: none;
                    background: transparent;
                    font-size: 13px;
                    font-weight: 500;
                    color: #64748b;
                    cursor: pointer;
                    flex-shrink: 0;
                    transition: color 0.15s ease;
                    white-space: nowrap;
                }
                .vendor-register-wrapper .vfp-tab::after {
                    content: '';
                    position: absolute;
                    left: 12px; right: 12px; bottom: -1px;
                    height: 2px;
                    background: transparent;
                    border-radius: 2px 2px 0 0;
                    transition: background 0.2s ease;
                }
                .vendor-register-wrapper .vfp-tab:hover:not(.is-active) { color: #0f172a; }
                .vendor-register-wrapper .vfp-tab.is-active {
                    color: #008695;
                    font-weight: 700;
                }
                .vendor-register-wrapper .vfp-tab.is-active::after { background: #008695; }
                .vendor-register-wrapper .vfp-tab-label-short { display: none; }

                /* Only the active section is visible */
                .vendor-register-wrapper .vfp-section { display: none !important; }
                .vendor-register-wrapper .vfp-section.is-active { display: block !important; }

                /* Prev / Next navigator */
                .vendor-register-wrapper .vfp-section-nav {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 10px;
                    padding: 12px 14px;
                    margin: 6px 0 16px;
                    background: #f8fafc;
                    border: 1px solid #eef2f7;
                    border-radius: 12px;
                }
                .vendor-register-wrapper .vfp-nav-btn {
                    display: inline-flex; align-items: center; justify-content: center;
                    height: 36px;
                    padding: 0 16px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #0f172a;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                }
                .vendor-register-wrapper .vfp-nav-btn:hover:not(:disabled) {
                    border-color: #008695;
                    color: #008695;
                    background: rgba(0,134,149,0.06);
                }
                .vendor-register-wrapper .vfp-nav-btn:disabled {
                    opacity: 0.35;
                    cursor: not-allowed;
                }
                .vendor-register-wrapper .vfp-nav-progress {
                    font-size: 11px;
                    font-weight: 600;
                    color: #64748b;
                    letter-spacing: 0.02em;
                }

                @media (max-width: 575.98px) {
                    .vendor-register-wrapper .vfp-tabs { padding: 0 4px; }
                    .vendor-register-wrapper .vfp-tab { padding: 8px 10px; font-size: 11.5px; }
                    .vendor-register-wrapper .vfp-tab-label-full { display: none; }
                    .vendor-register-wrapper .vfp-tab-label-short { display: inline; }
                    .vendor-register-wrapper .vfp-section-nav {
                        padding: 8px 10px;
                        margin: 4px 0 10px;
                    }
                    .vendor-register-wrapper .vfp-nav-btn { height: 30px; padding: 0 10px; font-size: 11px; }
                    .vendor-register-wrapper .vfp-nav-progress { font-size: 10px; }
                }

                /* Map column fills the row height alongside the left form column */
                .vendor-register-wrapper .vfp-map-col {
                    display: flex;
                    flex-direction: column;
                }
                .vendor-register-wrapper .vfp-map-box {
                    flex: 1 1 auto;
                    min-height: 0;
                }
                @media (max-width: 991.98px) {
                    .vendor-register-wrapper .vfp-map-box { min-height: 220px; height: 220px; }
                }

                /* "Use current location" button beside the Search Location label */
                /* No-brand empty state inside the brand AsyncSelect dropdown */
                .brand-noresult {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    padding: 16px 12px;
                    color: #64748b;
                }
                .brand-noresult-icon { font-size: 22px; opacity: 0.7; margin-bottom: 4px; }
                .brand-noresult-title {
                    font-size: 12px; font-weight: 700; color: #0f172a; margin-bottom: 2px;
                }
                .brand-noresult-sub { font-size: 10.5px; color: #94a3b8; margin-bottom: 10px; }
                .brand-noresult-btn {
                    display: inline-flex; align-items: center; gap: 5px;
                    background: #288d9d; color: #fff; border: none;
                    padding: 5px 12px; border-radius: 6px;
                    font-size: 11px; font-weight: 600; cursor: pointer;
                    box-shadow: 0 2px 6px rgba(40,141,157,0.25);
                    transition: background 0.15s ease;
                }
                .brand-noresult-btn:hover { background: #1f6f7c; }

                /* Register brand modal — 500px hard-locked shell */
                .register-brand-modal-content {
                    height: 500px !important;
                    max-height: 500px !important;
                    min-height: 500px !important;
                    overflow: hidden !important;
                    border: none !important;
                    border-radius: 6px !important;
                    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
                }
                /* Mobile view — render as a bottom sheet */
                @media (max-width: 575.98px) {
                    /* Kill Bootstrap's body-scrollbar compensation padding
                       that shifts everything to the left when the modal opens */
                    body.modal-open {
                        padding-right: 0 !important;
                    }
                    /* Pin the modal container to the bottom of the viewport,
                       stretched edge to edge — width:100% NOT 100vw so it
                       ignores any residual body padding. */
                    .modal.register-brand-modal-root {
                        display: flex !important;
                        flex-direction: column !important;
                        justify-content: flex-end !important;
                        align-items: stretch !important;
                        left: 0 !important;
                        right: 0 !important;
                        width: 100% !important;
                        padding: 0 !important;
                        overflow: hidden !important;
                    }
                    .register-brand-modal.modal-dialog {
                        max-width: 100% !important;
                        width: 100% !important;
                        margin: 0 !important;
                        pointer-events: auto !important;
                    }
                    .register-brand-modal-content {
                        width: 100% !important;
                        height: 85vh !important;
                        max-height: 85vh !important;
                        min-height: 85vh !important;
                        border-radius: 8px 8px 0 0 !important;
                        box-shadow: 0 -12px 32px rgba(15, 23, 42, 0.18) !important;
                    }
                    /* Slide-up entrance instead of fade-down */
                    .modal.fade .register-brand-modal.modal-dialog {
                        transform: translateY(100%) !important;
                        transition: transform 0.28s ease-out !important;
                    }
                    .modal.show .register-brand-modal.modal-dialog {
                        transform: translateY(0) !important;
                    }
                }
                @media (max-height: 540px) {
                    .register-brand-modal-content {
                        height: calc(100vh - 32px) !important;
                        max-height: calc(100vh - 32px) !important;
                        min-height: calc(100vh - 32px) !important;
                    }
                }
                /* Hide the scrollbar but keep scroll functional */
                .register-brand-modal .modal-body {
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                }
                .register-brand-modal .modal-body::-webkit-scrollbar {
                    display: none;
                    width: 0;
                    height: 0;
                }

                .vendor-register-wrapper .use-current-location-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    height: 26px;
                    padding: 0 10px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #008695;
                    background: transparent;
                    border: 1px solid rgba(0, 134, 149, 0.3);
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    white-space: nowrap;
                }
                .vendor-register-wrapper .use-current-location-btn:hover:not(:disabled) {
                    background: rgba(0, 134, 149, 0.08);
                    border-color: #008695;
                }
                .vendor-register-wrapper .use-current-location-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
                .vendor-register-wrapper .use-current-location-btn .spinner-border-sm {
                    width: 12px;
                    height: 12px;
                    border-width: 1.5px;
                }

                /* Business: stretch upload boxes to match left column height */
                @media (min-width: 768px) {
                    .vendor-register-wrapper [data-section="business"] .image-upload-container {
                        height: 180px !important;
                        min-height: 180px !important;
                    }
                }

                /* ===== Fixed bottom "your data is secure" note ===== */
                .vendor-register-wrapper .vendor-secure-note {
                    position: fixed;
                    left: 0; right: 0; bottom: 0;
                    z-index: 90;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 8px 14px calc(8px + env(safe-area-inset-bottom, 0px));
                    font-size: 11px;
                    font-weight: 500;
                    color: #475569;
                    background: rgba(255,255,255,0.94);
                    backdrop-filter: blur(8px);
                    border-top: 1px solid #eef2f7;
                    box-shadow: none;
                    text-align: center;
                    line-height: 1.35;
                }
                .vendor-register-wrapper .vendor-secure-note svg { color: #15803d; flex-shrink: 0; }
                .vendor-register-wrapper .vendor-secure-note-short { display: none; }
                .vendor-register-wrapper .vendor-register-container { padding-bottom: 56px !important; }
                @media (max-width: 767.98px) {
                    /* Show short text as a single line, sit flush at viewport bottom */
                    .vendor-register-wrapper .vendor-secure-note-full { display: none; }
                    .vendor-register-wrapper .vendor-secure-note-short { display: inline; }
                    .vendor-register-wrapper .vendor-secure-note {
                        font-size: 10px;
                        padding: 5px 10px calc(5px + env(safe-area-inset-bottom, 0px));
                        gap: 5px;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                    /* Mobile submit bar becomes truly fixed and sits directly on top of the note */
                    .vendor-register-wrapper .vendor-action-bar-mobile {
                        position: fixed !important;
                        left: 0; right: 0;
                        bottom: calc(24px + env(safe-area-inset-bottom, 0px)) !important;
                        z-index: 91;
                        margin: 0 !important;
                        border-radius: 0 !important;
                        border-left: 0 !important;
                        border-right: 0 !important;
                        border-bottom: 0 !important;
                        padding: 8px 12px !important;
                        box-shadow: none !important;
                    }
                    .vendor-register-wrapper .vendor-register-container { padding-bottom: 96px !important; }
                }

                /* ===== Store Timings: modern desktop table + mobile cards ===== */
                .vendor-register-wrapper [data-section="timings"] .card-body { padding: 12px 16px !important; }

                .vendor-register-wrapper .vfp-timings-table-wrap {
                    border: 1px solid #eef2f7;
                    border-radius: 12px;
                    overflow: hidden;
                    background: #fff;
                }
                .vendor-register-wrapper .vfp-timings-table {
                    width: 100%;
                    border-collapse: separate;
                    border-spacing: 0;
                    margin: 0;
                }
                .vendor-register-wrapper .vfp-timings-table thead th {
                    background: #f8fafc;
                    color: #475569;
                    font-size: 10px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                    padding: 10px 14px;
                    border-bottom: 1px solid #eef2f7;
                    text-align: left;
                    white-space: nowrap;
                }
                .vendor-register-wrapper .vfp-timings-table tbody td {
                    padding: 8px 14px;
                    border-bottom: 1px solid #f1f5f9;
                    font-size: 12px;
                    color: #0f172a;
                    vertical-align: middle;
                }
                .vendor-register-wrapper .vfp-timings-table tbody tr:last-child td { border-bottom: 0; }
                .vendor-register-wrapper .vfp-timings-table tbody tr.is-closed td { opacity: 0.6; }
                .vendor-register-wrapper .vfp-timings-table .vfp-day-cell {
                    font-weight: 600;
                    letter-spacing: -0.01em;
                }

                .vendor-register-wrapper .vfp-status-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 3px 10px;
                    border-radius: 999px;
                    font-size: 10.5px;
                    font-weight: 600;
                    letter-spacing: 0.01em;
                    border: 1px solid transparent;
                }
                .vendor-register-wrapper .vfp-status-chip.is-open {
                    background: rgba(34, 197, 94, 0.10);
                    color: #15803d;
                    border-color: rgba(34, 197, 94, 0.25);
                }
                .vendor-register-wrapper .vfp-status-chip.is-closed {
                    background: rgba(148, 163, 184, 0.14);
                    color: #64748b;
                    border-color: rgba(148, 163, 184, 0.25);
                }
                .vendor-register-wrapper .vfp-status-dot {
                    width: 6px; height: 6px; border-radius: 50%;
                    background: currentColor;
                }

                .vendor-register-wrapper .vfp-time-input {
                    height: 30px !important;
                    padding: 4px 8px !important;
                    font-size: 12px !important;
                    border-radius: 6px !important;
                    border: 1px solid #e2e8f0 !important;
                    width: 118px !important;
                    background: #fff !important;
                    color: #0f172a !important;
                }
                .vendor-register-wrapper .vfp-time-input:focus {
                    border-color: #288d9d !important;
                    box-shadow: 0 0 0 3px rgba(40,141,157,0.12) !important;
                    outline: none;
                }
                .vendor-register-wrapper .vfp-time-input:disabled {
                    background: #f8fafc !important;
                    color: #94a3b8 !important;
                    cursor: not-allowed;
                }

                .vendor-register-wrapper .vfp-timings-switch .MuiSwitch-root { padding: 4px; }
                .vendor-register-wrapper .vfp-timings-switch .MuiSwitch-track { border-radius: 999px; }

                /* Mobile: cards */
                .vendor-register-wrapper .vfp-timings-cards { display: none; }
                @media (max-width: 767.98px) {
                    .vendor-register-wrapper .vfp-timings-table-wrap { display: none; }
                    .vendor-register-wrapper .vfp-timings-cards {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                    }
                    .vendor-register-wrapper .vfp-timing-card {
                        border: 1px solid #eef2f7;
                        border-radius: 12px;
                        background: #fff;
                        padding: 10px 12px;
                        transition: border-color 0.15s ease, background 0.15s ease;
                    }
                    .vendor-register-wrapper .vfp-timing-card.is-closed {
                        background: #f8fafc;
                    }
                    .vendor-register-wrapper .vfp-timing-card-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 8px;
                        margin-bottom: 8px;
                    }
                    .vendor-register-wrapper .vfp-timing-day {
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        min-width: 0;
                    }
                    .vendor-register-wrapper .vfp-day-name {
                        font-size: 12.5px;
                        font-weight: 700;
                        color: #0f172a;
                        letter-spacing: -0.01em;
                    }
                    .vendor-register-wrapper .vfp-timing-card-times {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 8px;
                    }
                    .vendor-register-wrapper .vfp-timing-field {
                        display: flex;
                        flex-direction: column;
                        gap: 3px;
                    }
                    .vendor-register-wrapper .vfp-timing-label {
                        font-size: 10px;
                        font-weight: 600;
                        color: #64748b;
                        text-transform: uppercase;
                        letter-spacing: 0.04em;
                    }
                    .vendor-register-wrapper .vfp-time-input {
                        width: 100% !important;
                        height: 34px !important;
                        font-size: 12px !important;
                    }
                    .vendor-register-wrapper .vfp-timing-card.is-closed .vfp-time-input { opacity: 0.55; }
                }

                /* Tighter vertical spacing between fields on desktop */
                @media (min-width: 768px) {
                    .vendor-register-wrapper .vendor-card .form-group.mb-3,
                    .vendor-register-wrapper .vendor-card .form-group.mb-4,
                    .vendor-register-wrapper .vendor-card .mb-3,
                    .vendor-register-wrapper .vendor-card .mb-4 {
                        margin-bottom: 8px !important;
                    }
                    .vendor-register-wrapper .vendor-card .row {
                        --bs-gutter-y: 0 !important;
                    }
                    .vendor-register-wrapper .vendor-card .card-body .row {
                        --bs-gutter-x: 12px !important;
                    }
                }

                /* ===== Compact size overrides (fits naturally without scrolling) ===== */
                .vendor-register-wrapper .vfp-tab { padding: 8px 12px; font-size: 11.5px; }
                .vendor-register-wrapper .vfp-nav-btn { height: 28px; padding: 0 10px; font-size: 10.5px; }
                .vendor-register-wrapper .vfp-nav-progress { font-size: 10px; }
                .vendor-register-wrapper .vfp-section-nav { padding: 6px 10px; margin: 4px 0 10px; }
                .vendor-register-wrapper .vfp-tabs { margin-bottom: 10px; }

                /* Narrower centered container on desktop for better readability */
                .vendor-register-wrapper .vendor-register-container {
                    max-width: 1080px;
                    margin: 0 auto !important;
                    padding: 8px 32px 28px !important;
                }
                @media (max-width: 991px) {
                    .vendor-register-wrapper .vendor-register-container {
                        padding: 8px 20px 28px !important;
                    }
                }

                .vendor-register-wrapper .vendor-card { border-radius: 10px !important; margin-bottom: 12px !important; }
                .vendor-register-wrapper .vendor-card-header {
                    padding: 10px 14px !important;
                    gap: 8px;
                }
                .vendor-register-wrapper .vendor-card-header-icon {
                    width: 26px !important;
                    height: 26px !important;
                    border-radius: 6px !important;
                    font-size: 12px !important;
                }
                .vendor-register-wrapper .vendor-card-header-title { font-size: 12.5px !important; }
                .vendor-register-wrapper .vendor-card-header-sub { font-size: 10.5px !important; margin-top: 1px !important; }
                .vendor-register-wrapper .vendor-card .card-body,
                .vendor-register-wrapper .vendor-card .p-4 { padding: 12px 14px !important; }

                .vendor-register-wrapper .form-label,
                .vendor-register-wrapper .form-label.fw-semibold {
                    font-size: 10.5px !important;
                    margin-bottom: 3px !important;
                    font-weight: 500 !important;
                    color: #475569 !important;
                }
                .vendor-register-wrapper .rounded-input,
                .vendor-register-wrapper .form-control,
                .vendor-register-wrapper .form-select {
                    font-size: 11.5px !important;
                    padding: 4px 10px !important;
                    border-radius: 6px !important;
                    height: 30px !important;
                }
                .vendor-register-wrapper textarea.form-control,
                .vendor-register-wrapper textarea.rounded-input {
                    height: auto !important;
                    min-height: 54px !important;
                }
                .vendor-register-wrapper .invalid-feedback,
                .vendor-register-wrapper .invalid-feedbacks { font-size: 9.5px !important; }

                .vendor-register-wrapper .image-upload-container {
                    padding: 8px !important;
                    min-height: 84px !important;
                }
                .vendor-register-wrapper .vendor-apply-monday-btn {
                    font-size: 10.5px !important;
                    padding: 4px 9px !important;
                    border-radius: 6px !important;
                }
                .vendor-register-wrapper .vendor-submit-btn {
                    min-width: 130px !important;
                    padding: 7px 16px !important;
                    font-size: 11.5px !important;
                    border-radius: 6px !important;
                }
                .vendor-register-wrapper .vendor-action-bar {
                    padding: 8px 12px !important;
                    border-radius: 8px !important;
                }

                /* Topbar shrink */
                .vendor-register-wrapper .vendor-topbar-inner { padding: 10px 16px; gap: 10px; }
                .vendor-register-wrapper .vendor-back-btn,
                .vendor-register-wrapper .vendor-contact-btn {
                    font-size: 12px;
                    padding: 6px 10px;
                    border-radius: 8px;
                    gap: 6px;
                }
                .vendor-register-wrapper .vendor-topbar-actions {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                }
                .vendor-register-wrapper .vendor-submit-header {
                    height: 34px !important;
                    padding: 6px 16px !important;
                    font-size: 12px !important;
                    min-width: 0 !important;
                    border-radius: 8px !important;
                }
                .vendor-register-wrapper .vendor-action-bar-mobile { display: none !important; }
                @media (max-width: 767.98px) {
                    .vendor-register-wrapper .vendor-submit-header { display: none !important; }
                    .vendor-register-wrapper .vendor-action-bar-mobile { display: flex !important; }
                }

                @media (max-width: 575.98px) {
                    .vendor-register-wrapper .vendor-register-container { padding: 6px 10px 24px !important; }
                    .vendor-register-wrapper .vendor-card-header { padding: 10px 12px !important; gap: 8px; }
                    .vendor-register-wrapper .vendor-card-header-icon {
                        width: 28px !important; height: 28px !important; font-size: 13px !important;
                    }
                    .vendor-register-wrapper .vendor-card-header-title { font-size: 12.5px !important; }
                    .vendor-register-wrapper .vendor-card-header-sub { font-size: 10.5px !important; }
                    .vendor-register-wrapper .vendor-card .card-body,
                    .vendor-register-wrapper .vendor-card .p-4 { padding: 12px !important; }
                    .vendor-register-wrapper .rounded-input,
                    .vendor-register-wrapper .form-control,
                    .vendor-register-wrapper .form-select {
                        font-size: 12px !important;
                        padding: 6px 8px !important;
                        height: 32px !important;
                    }
                    .vendor-register-wrapper .vendor-submit-btn {
                        min-width: 100% !important;
                        padding: 10px 16px !important;
                    }
                    .vendor-register-wrapper .vendor-topbar-inner { padding: 8px 12px; }
                    .vendor-register-wrapper .vendor-back-btn span,
                    .vendor-register-wrapper .vendor-contact-btn span { display: none; }
                    .vendor-register-wrapper .vendor-back-btn,
                    .vendor-register-wrapper .vendor-contact-btn { padding: 6px 8px; }
                }

                /* ===== Mobile responsive: two fields per row where possible ===== */
                @media (max-width: 767.98px) {
                    /* Trim row/col gutters so fields hug the edge cleanly */
                    .vendor-register-wrapper .vendor-card .row {
                        margin-left: -6px !important;
                        margin-right: -6px !important;
                    }
                    .vendor-register-wrapper .vendor-card .row > [class*="col-"] {
                        padding-left: 6px !important;
                        padding-right: 6px !important;
                    }

                    /* Default: any col-md-6 inside a card â†’ 50/50 on mobile */
                    .vendor-register-wrapper .vendor-card .row > .col-md-6 {
                        flex: 0 0 50% !important;
                        max-width: 50% !important;
                    }

                    /* Exception: outer wrapper halves keep full width so left/right stack */
                    .vendor-register-wrapper [data-section="location"] .card-body > .row > .col-md-12.col-lg-6,
                    .vendor-register-wrapper [data-section="business"] .card-body > .row > .col-md-12.col-lg-5,
                    .vendor-register-wrapper [data-section="business"] .card-body > .row > .col-md-12.col-lg-7 {
                        flex: 0 0 100% !important;
                        max-width: 100% !important;
                    }

                    /* Basic Info: image column pops to top and takes full width */
                    .vendor-register-wrapper [data-section="basic"] .card-body > .row > .row {
                        display: flex;
                        flex-wrap: wrap;
                    }
                    .vendor-register-wrapper [data-section="basic"] .card-body > .row > .row > .col-md-4 {
                        order: -1;
                        flex: 0 0 100% !important;
                        max-width: 100% !important;
                    }
                    .vendor-register-wrapper [data-section="basic"] .card-body > .row > .row > .col-md-8 {
                        flex: 0 0 100% !important;
                        max-width: 100% !important;
                    }
                    /* Business uploads: 2 per row on mobile (3 â†’ 2+1) */
                    .vendor-register-wrapper [data-section="business"] .card-body .row > .col-md-4 {
                        flex: 0 0 50% !important;
                        max-width: 50% !important;
                    }

                    /* Image upload boxes: shrink height on mobile */
                    .vendor-register-wrapper .image-upload-container {
                        min-height: 120px !important;
                        height: 120px !important;
                    }
                    .vendor-register-wrapper [data-section="basic"] .image-upload-container {
                        min-height: 160px !important;
                        height: 180px !important;
                    }
                    /* Labels + small text tighten */
                    .vendor-register-wrapper .image-upload-container p { font-size: 10px !important; }
                    .vendor-register-wrapper .image-upload-container small { font-size: 9.5px !important; }
                }

                /* Top nav */
                .vendor-register-topbar {
                    background: #ffffff;
                    border-bottom: 1px solid #e6ebf1;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
                }
                .vendor-topbar-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 14px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 16px;
                }
                .vendor-back-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: #f4f6fa;
                    border: 1px solid #e2e7ee;
                    color: #334155;
                    font-weight: 500;
                    font-size: 14px;
                    padding: 8px 14px;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                    cursor: pointer;
                }
                .vendor-back-btn:hover {
                    background: #eef2f7;
                    color: #0f172a;
                    border-color: #cbd5e1;
                    transform: translateX(-2px);
                }
                /* Hero */
                .vendor-register-hero {
                    padding: 40px 24px 24px;
                }
                .vendor-hero-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                    text-align: center;
                }
                .vendor-hero-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: rgba(40, 141, 157, 0.1);
                    color: #288d9d;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 6px 12px;
                    border-radius: 999px;
                    margin-bottom: 14px;
                    letter-spacing: 0.3px;
                    text-transform: uppercase;
                }
                .vendor-hero-title {
                    font-size: 30px;
                    font-weight: 700;
                    color: #0f172a;
                    margin-bottom: 8px;
                    letter-spacing: -0.4px;
                }
                .vendor-hero-subtitle {
                    font-size: 15px;
                    color: #64748b;
                    margin: 0;
                }

                /* Container */
                .vendor-register-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 8px 24px 48px;
                }

                /* Modern Cards */
                .vendor-card {
                    border: 1px solid #e6ebf1 !important;
                    border-radius: 16px !important;
                    background: #ffffff;
                    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04),
                                0 4px 12px rgba(16, 24, 40, 0.03);
                    overflow: hidden;
                }
                .vendor-card-header {
                    background: #ffffff !important;
                    border-bottom: 1px solid #eef2f7 !important;
                    padding: 20px 24px !important;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }
                .vendor-card-header-split {
                    justify-content: space-between;
                    flex-wrap: wrap;
                    row-gap: 12px;
                }
                .vendor-card-header-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: rgba(40, 141, 157, 0.10);
                    color: #288d9d;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    flex-shrink: 0;
                }
                .vendor-card-header-title {
                    font-size: 16px;
                    font-weight: 700;
                    color: #0f172a;
                    line-height: 1.3;
                }
                .vendor-card-header-sub {
                    font-size: 13px;
                    color: #64748b;
                    margin-top: 2px;
                }

                /* Form fields */
                .rounded-input {
                    border-radius: 10px !important;
                    border: 1px solid #d5dbe4;
                    padding: 10px 14px;
                    font-size: 14px;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease;
                }
                .rounded-input:focus {
                    border-color: #288d9d;
                    box-shadow: 0 0 0 3px rgba(40, 141, 157, 0.15);
                }
                .form-label.fw-semibold {
                    font-size: 13px;
                    color: #334155;
                    margin-bottom: 6px;
                }

                /* Image upload */
                .image-upload-container {
                    transition: all 0.2s ease !important;
                    border: 2px dashed #d5dbe4 !important;
                    background: #fafbfd;
                }
                .image-upload-container:hover {
                    border-color: #288d9d !important;
                    background: #f0f9fb;
                }

                /* Store timings table */
                .vendor-apply-monday-btn {
                    border-radius: 10px !important;
                    font-size: 13px !important;
                    padding: 8px 16px !important;
                    font-weight: 500 !important;
                }

                /* Marker */
                .marker_icon {
                    animation: bounce 1s infinite;
                }
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                /* Action bar */
                .vendor-action-bar {
                    position: sticky;
                    bottom: 0;
                    display: flex;
                    justify-content: flex-end;
                    gap: 12px;
                    padding: 16px 20px;
                    background: rgba(255, 255, 255, 0.92);
                    backdrop-filter: blur(8px);
                    border: 1px solid #e6ebf1;
                    border-radius: 14px;
                    box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
                    margin-top: 8px;
                }
                .vendor-submit-btn {
                    min-width: 180px;
                    border-radius: 10px !important;
                    background: linear-gradient(135deg, #288d9d 0%, #1f6f7c 100%) !important;
                    border: none !important;
                    color: #ffffff !important;
                    font-weight: 600 !important;
                    padding: 10px 22px !important;
                    box-shadow: 0 4px 12px rgba(40, 141, 157, 0.25);
                    transition: all 0.2s ease !important;
                }
                .vendor-submit-btn:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 6px 16px rgba(40, 141, 157, 0.35);
                }
                .vendor-submit-btn:disabled {
                    opacity: 0.7;
                }

                /* Contact button — plain, no fill */
                .vendor-contact-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: transparent;
                    border: 1px solid #e2e8f0;
                    color: #334155;
                    font-weight: 500;
                    font-size: 14px;
                    padding: 8px 16px;
                    border-radius: 10px;
                    box-shadow: none;
                    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
                    cursor: pointer;
                }
                .vendor-contact-btn:hover {
                    color: #0f172a;
                    border-color: #cbd5e1;
                    background: #f8fafc;
                }

                /* Contact modal */
                :global(.vendor-contact-modal .modal-content) {
                    border: none;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 20px 60px rgba(16, 24, 40, 0.18);
                }
                :global(.vendor-contact-modal .modal-header) {
                    background: linear-gradient(135deg, #288d9d 0%, #1f6f7c 100%);
                    color: #ffffff;
                    border-bottom: none;
                    padding: 22px 28px;
                    display: flex;
                    align-items: center;
                }
                :global(.vendor-contact-modal .modal-title) {
                    font-weight: 600;
                    font-size: 17px;
                    line-height: 1;
                    margin: 0;
                    color: #ffffff;
                }
                :global(.vendor-contact-modal .btn-close) {
                    filter: brightness(0) invert(1);
                    opacity: 1;
                    margin: 0;
                    width: 32px;
                    height: 32px;
                    padding: 0;
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.18);
                    background-size: 11px 11px;
                    background-position: center;
                    background-repeat: no-repeat;
                    transition: background-color 0.2s ease, transform 0.2s ease;
                }
                :global(.vendor-contact-modal .btn-close:hover) {
                    background-color: rgba(255, 255, 255, 0.3);
                    transform: rotate(90deg);
                }
                :global(.vendor-contact-modal .btn-close:focus) {
                    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
                }
                :global(.vendor-contact-modal .modal-body) {
                    padding: 28px;
                    background: #ffffff;
                }
                .vendor-contact-intro {
                    font-size: 14px;
                    color: #64748b;
                    margin: 0 0 22px;
                    line-height: 1.55;
                }
                .vendor-contact-row {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 18px 20px;
                    background: #f8fafc;
                    border: 1px solid #e6ebf1;
                    border-radius: 12px;
                    margin-bottom: 14px;
                    text-decoration: none;
                    transition: all 0.2s ease;
                }
                .vendor-contact-row:last-child { margin-bottom: 0; }
                .vendor-contact-row:hover {
                    border-color: #288d9d;
                    background: #f0f9fb;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(40, 141, 157, 0.1);
                }
                .vendor-contact-icon {
                    width: 42px;
                    height: 42px;
                    border-radius: 10px;
                    background: rgba(40, 141, 157, 0.1);
                    color: #288d9d;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                .vendor-contact-label {
                    font-size: 12px;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                    font-weight: 600;
                }
                .vendor-contact-value {
                    font-size: 15px;
                    color: #0f172a;
                    font-weight: 600;
                    margin-top: 2px;
                }

                @media (max-width: 768px) {
                    .vendor-hero-title { font-size: 22px; }
                    .vendor-hero-subtitle { font-size: 14px; }
                    .vendor-register-container { padding: 4px 10px 24px; }
                    .vendor-register-hero { padding: 24px 12px 16px; }
                    .vendor-contact-btn span { display: none; }
                    .vendor-contact-btn { padding: 8px 10px; }
                    .vendor-topbar-inner { padding: 12px 14px; }
                    .vendor-back-btn { padding: 8px 12px; font-size: 13px; }

                    /* Tighter cards so form fields get more width */
                    :global(.vendor-card .card-body) { padding: 16px !important; }
                    .vendor-card-header { padding: 14px 16px !important; gap: 10px; }
                    .vendor-card-header-icon { width: 36px; height: 36px; font-size: 16px; }
                    .vendor-card-header-title { font-size: 15px; }
                    .vendor-card-header-sub { font-size: 12px; }
                    .vendor-card-header-split { flex-direction: column; align-items: flex-start !important; }
                    .vendor-apply-monday-btn { width: 100%; }

                    /* Full-width submit button on mobile */
                    .vendor-action-bar {
                        padding: 12px;
                        border-radius: 12px;
                    }
                    .vendor-submit-btn {
                        width: 100%;
                        min-width: 0;
                    }
                }

                @media (max-width: 480px) {
                    .vendor-register-container { padding: 4px 8px 20px; }
                    :global(.vendor-card .card-body) { padding: 14px !important; }
                    .vendor-card-header { padding: 12px 14px !important; }
                }
            `}</style>

            {/* Success Modal */}
            <VendorRegistrationSuccessModal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
            />

            {/* Contact Modal */}
            <Modal
                show={showContactModal}
                onHide={() => setShowContactModal(false)}
                centered
                dialogClassName="vendor-contact-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Get in touch</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="vendor-contact-intro">
                        Need help with your registration? Reach out to our support team â€” we're happy to help.
                    </p>

                    <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="vendor-contact-row">
                        <div className="vendor-contact-icon">
                            <FiPhone size={18} />
                        </div>
                        <div>
                            <div className="vendor-contact-label">Phone</div>
                            <div className="vendor-contact-value">{contactInfo.phone}</div>
                        </div>
                    </a>

                    <a href={`mailto:${contactInfo.email}`} className="vendor-contact-row">
                        <div className="vendor-contact-icon">
                            <FiMail size={18} />
                        </div>
                        <div>
                            <div className="vendor-contact-label">Email</div>
                            <div className="vendor-contact-value">{contactInfo.email}</div>
                        </div>
                    </a>
                </Modal.Body>
            </Modal>

            {/* Register Brand Modal */}
            <Modal
                show={showRegisterBrandModal}
                onHide={closeRegisterBrandModal}
                backdrop={creatingBrand ? 'static' : true}
                keyboard={!creatingBrand}
                dialogClassName="register-brand-modal"
                contentClassName="register-brand-modal-content"
                className="register-brand-modal-root"
                size="lg"
            >
                <Modal.Header
                    closeButton
                    style={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                        borderBottom: '1px solid #eef2f7',
                        padding: '10px 18px',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            fontSize: 16,
                            fontWeight: 700,
                            color: '#0f172a',
                            lineHeight: 1.2,
                            letterSpacing: '-0.01em',
                            margin: 0,
                            minWidth: 0,
                            flex: 1,
                        }}
                    >
                        Register a new brand
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, background: '#f8fafc', flex: '1 1 auto', minHeight: 0, overflowY: 'auto' }}>
                    {/* ── Section 1: Logo + Brand name + Available categories ─── */}
                    <div style={{ padding: '14px 18px', background: '#ffffff' }}>
                        <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                            {/* Avatar-style image uploader */}
                            <div style={{ flexShrink: 0 }}>
                                <label
                                    htmlFor="rbm-image-input"
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 110,
                                        height: 110,
                                        borderRadius: 6,
                                        border: newBrandImagePreview ? '1px solid #e2e8f0' : '2px dashed #cbd5e1',
                                        background: newBrandImagePreview ? '#fff' : 'linear-gradient(180deg, #fbfcfd 0%, #f4f7fa 100%)',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        transition: 'all 0.15s ease',
                                    }}
                                >
                                    {newBrandImagePreview ? (
                                        <>
                                            <img
                                                src={newBrandImagePreview}
                                                alt="Brand"
                                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                            />
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    padding: '4px 0',
                                                    background: 'rgba(15,23,42,0.72)',
                                                    color: '#fff',
                                                    fontSize: 9.5,
                                                    fontWeight: 700,
                                                    textAlign: 'center',
                                                    letterSpacing: '0.05em',
                                                    textTransform: 'uppercase',
                                                }}
                                            >
                                                Change
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                                            <span
                                                style={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: 5,
                                                    background: 'rgba(40,141,157,0.10)',
                                                    color: '#288d9d',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <FiImage size={18} />
                                            </span>
                                            <span style={{ fontSize: 10.5, fontWeight: 600, color: '#64748b', letterSpacing: '0.02em' }}>
                                                Add logo
                                            </span>
                                            <span style={{ fontSize: 9, color: '#94a3b8', fontWeight: 500, letterSpacing: '0.02em' }}>
                                                JPG · PNG · &lt; 2MB
                                            </span>
                                        </div>
                                    )}
                                </label>
                                <input
                                    id="rbm-image-input"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleNewBrandImage}
                                    style={{ display: 'none' }}
                                />
                            </div>

                            {/* Right side: Brand name + Available categories */}
                            <div style={{ flex: 1, minWidth: 200, display: 'flex', flexDirection: 'column', gap: 0 }}>
                                {/* Brand name */}
                                <div style={{ marginBottom: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 3 }}>
                                        <label style={{ fontSize: 11, fontWeight: 700, color: '#0f172a', letterSpacing: '0.01em', margin: 0 }}>
                                            Brand Name
                                        </label>
                                        <span style={{ fontSize: 9.5, color: newBrandName.length > 70 ? '#dc2626' : '#94a3b8', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                                            {newBrandName.length}/80
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        value={newBrandName}
                                        onChange={(e) => setNewBrandName(e.target.value)}
                                        placeholder="e.g. Nike, Apple, Zara"
                                        maxLength={80}
                                        style={{
                                            width: '100%',
                                            height: 34,
                                            padding: '0 12px',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: 4,
                                            fontSize: 12,
                                            color: '#0f172a',
                                            outline: 'none',
                                            background: '#fff',
                                            transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
                                        }}
                                        onFocus={(e) => { e.target.style.borderColor = '#288d9d'; e.target.style.boxShadow = '0 0 0 3px rgba(40,141,157,0.14)' }}
                                        onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none' }}
                                    />
                                </div>

                                {/* Available categories - pill chips */}
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: '#0f172a', display: 'block', marginBottom: 5, letterSpacing: '0.01em' }}>
                                        Available Categories
                                    </label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                                        {categoriesLoading ? (
                                            <span style={{ fontSize: 11, color: '#94a3b8' }}>Loading categories...</span>
                                        ) : allCategories.length === 0 ? (
                                            <span style={{ fontSize: 11, color: '#94a3b8' }}>No categories available</span>
                                        ) : (
                                            allCategories.map((cat) => {
                                                const catId = cat.value ?? cat.id
                                                const picked = isCategoryPicked(catId)
                                                return (
                                                    <button
                                                        key={catId}
                                                        type="button"
                                                        onClick={() => toggleBrandCategory(cat)}
                                                        style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: 4,
                                                            padding: '4px 10px',
                                                            border: '1px solid ' + (picked ? '#288d9d' : '#e2e8f0'),
                                                            borderRadius: 999,
                                                            background: picked ? '#288d9d' : '#fff',
                                                            color: picked ? '#fff' : '#334155',
                                                            fontSize: 10.5,
                                                            fontWeight: picked ? 600 : 500,
                                                            cursor: 'pointer',
                                                            transition: 'all 0.15s ease',
                                                            boxShadow: picked ? '0 2px 6px rgba(40,141,157,0.22)' : 'none',
                                                        }}
                                                    >
                                                        {picked ? (
                                                            <FiCheck size={10} strokeWidth={3} />
                                                        ) : (
                                                            <FiPlus size={10} strokeWidth={2.5} color="#94a3b8" />
                                                        )}
                                                        {cat.label || cat.name}
                                                    </button>
                                                )
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Section 2: Subcategory selection (full width) ─── */}
                    <div style={{ padding: '14px 18px', background: '#ffffff', borderTop: '1px solid #eef2f7' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#0f172a', letterSpacing: '0.01em' }}>
                                Subcategory Selection
                            </div>
                            {brandCategoriesForm.length > 0 && (
                                <span
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 4,
                                        fontSize: 9.5,
                                        fontWeight: 700,
                                        color: '#288d9d',
                                        background: 'rgba(40,141,157,0.10)',
                                        border: '1px solid rgba(40,141,157,0.18)',
                                        borderRadius: 999,
                                        padding: '2px 8px',
                                        letterSpacing: '0.02em',
                                    }}
                                >
                                    <FiCheck size={9} />
                                    {brandCategoriesForm.length} categor{brandCategoriesForm.length === 1 ? 'y' : 'ies'}
                                    <span style={{ opacity: 0.55 }}>·</span>
                                    {brandCategoriesForm.reduce((sum, c) => sum + c.selectedSubs.length, 0)} subs
                                </span>
                            )}
                        </div>
                        <div>
                            {brandCategoriesForm.length === 0 ? (
                                <div
                                    style={{
                                        border: '1px dashed #e2e8f0',
                                        borderRadius: 5,
                                        background: '#fafbfc',
                                        padding: '20px 16px',
                                        textAlign: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 4,
                                            background: '#eef2f7',
                                            color: '#94a3b8',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: 6,
                                        }}
                                    >
                                        <FiTag size={14} />
                                    </div>
                                    <div style={{ fontSize: 11, fontWeight: 600, color: '#334155', marginBottom: 2 }}>
                                        No categories picked yet
                                    </div>
                                    <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 500 }}>
                                        Tap a chip above to add a category.
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    {brandCategoriesForm.map((cat) => (
                                        <div
                                            key={cat.categoryId}
                                            style={{
                                                background: '#fff',
                                                border: '1px solid #eef2f7',
                                                borderRadius: 5,
                                                padding: '8px 10px',
                                                boxShadow: '0 1px 2px rgba(15,23,42,0.03)',
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6, marginBottom: 6 }}>
                                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
                                                    <span
                                                        style={{
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: 3,
                                                            background: 'rgba(40,141,157,0.10)',
                                                            color: '#288d9d',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <FiTag size={10} />
                                                    </span>
                                                    <span style={{ fontSize: 11.5, fontWeight: 700, color: '#0f172a' }}>{cat.categoryName}</span>
                                                    <span
                                                        style={{
                                                            fontSize: 9,
                                                            fontWeight: 700,
                                                            color: cat.selectedSubs.length > 0 ? '#288d9d' : '#94a3b8',
                                                            background: cat.selectedSubs.length > 0 ? 'rgba(40,141,157,0.10)' : '#f1f5f9',
                                                            borderRadius: 999,
                                                            padding: '1px 6px',
                                                            letterSpacing: '0.02em',
                                                        }}
                                                    >
                                                        {cat.selectedSubs.length} sub{cat.selectedSubs.length === 1 ? '' : 's'}
                                                    </span>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => toggleBrandCategory({ value: cat.categoryId })}
                                                    aria-label={`Remove ${cat.categoryName}`}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: 3,
                                                        border: '1px solid #e2e8f0',
                                                        background: '#fff',
                                                        color: '#64748b',
                                                        cursor: 'pointer',
                                                        padding: 0,
                                                        transition: 'all 0.15s ease',
                                                    }}
                                                    onMouseEnter={(e) => { e.currentTarget.style.color = '#dc2626'; e.currentTarget.style.borderColor = '#fecaca'; e.currentTarget.style.background = '#fef2f2' }}
                                                    onMouseLeave={(e) => { e.currentTarget.style.color = '#64748b'; e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#fff' }}
                                                >
                                                    <FiX size={11} />
                                                </button>
                                            </div>
                                            <AsyncSelect
                                                isMulti
                                                cacheOptions
                                                defaultOptions={cat.subOptions}
                                                loadOptions={(input) => {
                                                    if (!input) return Promise.resolve(cat.subOptions)
                                                    const q = input.toLowerCase()
                                                    return Promise.resolve(cat.subOptions.filter((s) => (s.label || '').toLowerCase().includes(q)))
                                                }}
                                                onChange={(v) => updateCategorySubs(cat.categoryId, v)}
                                                value={cat.selectedSubs}
                                                placeholder={cat.loadingSubs ? 'Loading...' : `Search subcategories in ${cat.categoryName}...`}
                                                noOptionsMessage={() => 'No matching subcategories'}
                                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: (b) => ({ ...b, zIndex: 10000 }),
                                                    menu: (b) => ({ ...b, borderRadius: 4, boxShadow: '0 8px 24px rgba(15,23,42,0.10)', fontSize: 11, overflow: 'hidden' }),
                                                    control: (b, s) => ({ ...b, minHeight: 30, borderRadius: 3, fontSize: 11, borderColor: s.isFocused ? '#288d9d' : '#e2e8f0', boxShadow: s.isFocused ? '0 0 0 3px rgba(40,141,157,0.14)' : 'none', ':hover': { borderColor: '#cbd5e1' }, background: '#fafbfc' }),
                                                    option: (b, s) => ({ ...b, fontSize: 11, padding: '5px 10px', backgroundColor: s.isSelected ? 'rgba(40,141,157,0.14)' : s.isFocused ? 'rgba(40,141,157,0.08)' : '#fff', color: '#0f172a', cursor: 'pointer', fontWeight: s.isSelected ? 600 : 500 }),
                                                    input: (b) => ({ ...b, fontSize: 11, margin: 0, padding: 0, color: '#0f172a' }),
                                                    multiValue: (b) => ({ ...b, backgroundColor: '#288d9d', color: '#fff', borderRadius: 999, padding: '0 1px 0 5px' }),
                                                    multiValueLabel: (b) => ({ ...b, color: '#fff', fontSize: 10, fontWeight: 600 }),
                                                    multiValueRemove: (b) => ({ ...b, color: '#fff', borderRadius: '0 999px 999px 0', ':hover': { backgroundColor: '#1f6f7c', color: '#fff' } }),
                                                    placeholder: (b) => ({ ...b, color: '#94a3b8', fontSize: 11 }),
                                                    valueContainer: (b) => ({ ...b, padding: '2px 6px', gap: 3 }),
                                                    indicatorsContainer: (b) => ({ ...b, height: 28 }),
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer
                    style={{
                        background: '#fff',
                        borderTop: '1px solid #eef2f7',
                        padding: '8px 16px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 6,
                    }}
                >
                    <button
                        type="button"
                        onClick={closeRegisterBrandModal}
                        disabled={creatingBrand}
                        style={{
                            background: '#fff',
                            border: '1px solid #e2e8f0',
                            color: '#0f172a',
                            padding: '5px 12px',
                            borderRadius: 3,
                            fontSize: 10.5,
                            fontWeight: 600,
                            cursor: creatingBrand ? 'not-allowed' : 'pointer',
                            opacity: creatingBrand ? 0.6 : 1,
                            transition: 'all 0.15s ease',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={submitNewBrand}
                        disabled={creatingBrand}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            background: 'linear-gradient(135deg, #288d9d 0%, #1f6f7c 100%)',
                            border: 'none',
                            color: '#fff',
                            padding: '5px 14px',
                            borderRadius: 3,
                            fontSize: 10.5,
                            fontWeight: 600,
                            cursor: creatingBrand ? 'not-allowed' : 'pointer',
                            opacity: creatingBrand ? 0.6 : 1,
                            boxShadow: '0 3px 8px rgba(40,141,157,0.25)',
                            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                        }}
                    >
                        {creatingBrand ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Registering...
                            </>
                        ) : (
                            <>
                                <FiPlus size={11} />
                                Register brand
                            </>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default RegisterManufacturer
